import { ContactUsType, LoyaltyChallengeConfig } from '@shared/models';

import {
  BARCODE_FORMAT,
  CampaignTypes,
  ChondrusSubType,
  DeviceType,
  DISPLAY_CONDITION,
  ProductCheckTabType,
  RewardFormat,
  ScanCheckMode,
  SubType,
  TitleType,
  Variants,
} from '../utils';

export const CHONDRUS_CONFIG: LoyaltyChallengeConfig = {
  currency: 'EUR',
  appIcon: 'assets/images/chondrus/favicon.ico',
  cssVariables: {
    'font-family': 'Roboto-Medium',
    'font-family-regular': 'Roboto-Medium',
    'font-family-normal': 'Balboa-Normal',
    'font-family-light': 'Balboa-Light',
    'font-family-roboto-light': 'Roboto-Light',
    'font-family-medium': 'Balboa-Medium',
    'font-family-roboto-medium': 'Roboto-Medium',
    'font-family-roboto-bold': 'Roboto-Bold',
    'font-family-bold': 'Balboa-Bold',
    'font-family-edouard-bold': 'Edouard-Bold',
    'font-family-edouard-condensed-semiBold': 'Edouard-Condensed-SemiBold',
    'font-family-edouard-condensed-bold': 'Edouard-Condensed-Bold',
    'font-family-edouard-condensed-regular': 'Edouard-Condensed-Regular',

    'navbar-height': '75px',
    'navbar-background-color': 'white',

    'nav-link-color': '#003494',
    'nav-link-font-size': '13px',
    'nav-link-active-color': 'white',

    'nav-item-bg-color': 'white',
    'nav-item-active-bg-color': 'white',
    'nav-item-hover-bg-color': '#F4F4F4',
    'nav-item-font-family': 'Balboa-Medium',

    'body-color': '#000000',
    'body-background-color': '#ffffff',

    'form-field-input-color': '#003494',

    'challenge-primary-color': '#003494',

    'tooltip-text-color': 'white',
    'tooltip-background-color': 'black',
  },
  rewardFormat: RewardFormat.PRICE,
  og: {
    title: 'Mes Parcours Gagnants | E.Leclerc',
    description:
      "Participez à vos parcours pour tenter de gagner jusqu'a 50€ avec la carte E.Leclerc",
  },
  rewardTemplate:
    '{points}<div style="font-family: var(--font-family-bold); color: white; font-size: 15px;">points</div>',
  pages: {
    availablePages: [
      'help',
      'login',
      'current',
      'history',
      'soon',
      'current-bis',
    ],
    help: {
      meta: {
        title: 'Mes Parcours Gagnants | E.Leclerc | Aide',
        keywords:
          'Tickets, E.Leclerc, Parcours, Cumulez, Participez, Gagnez, Carte, Fidélité',
        description:
          "Participez à vos parcours pour tenter de gagner jusqu'a 50€ avec la carte E.Leclerc",
      },
      header: {
        background: '#003494',
        goBackButton: {
          text: 'Retour à mes défis',
          backgroundColor: '#003494',
          color: 'white',
          fontFamily: 'var(--font-family-light)',
          borderRadius: '60px',
        },
        bannerAlternativeText:
          'Bannière avec liens vers Aide et Mentions légales',
        backButton: {
          imageUrl: 'assets/images/chondrus/arrow-back.webp',
          alternativeText: 'Retourner à la page de connexion',
          ariaLabel: 'Redirection à la page de connexion',
        },
        logo: {
          imageUrl: 'assets/images/chondrus/logo-mes-parcours-gagnants.webp',
          ariaLabel: 'Redirection vers la page de connexion',
          alternativeText: 'Logo Mes Parcours Gagnants',
          width: 819,
          height: 423,
        },
        howToPlay: {
          specificDisplayCondition: DISPLAY_CONDITION.NEVER,
        },
      },
      faqVariant: {
        variant: Variants.VARIANT_1,
        title: {
          displayWhenCampaignBis: true,
          type: TitleType.TEXT,
          label:
            '<h1 style="color: #003494; margin: unset; font-family: var(--font-family-bold); font-size: 30px; line-height: 1.2;">Besoin d’aide ?</h1><h2 style="color: #003494; font-size: 30px; line-height: 1.2; font-family: var(--font-family-bold); margin: unset; text-transform: uppercase; text-align: center;">Toutes vos réponses ici</h2>',
          styles: {
            marginTop: '1rem',
            lineHeight: '40px',
            textAlign: 'center',
            marginBottom: '2rem',
            textTransform: 'uppercase',
          },
        },
        questions: [
          {
            title: 'Combien de temps durent les Parcours Gagnants E.Leclerc ? ',
            content:
              'Les Parcours Gagnants E.Leclerc sont des opérations d’un mois mises en place du 1er janvier au 31 décembre. Les dates exactes de chaque opération figurent dans les mails qui vous seront envoyés pour participer et sur la page de jeux',
          },
          {
            title: 'Suis-je obligé(e) de sélectionner 10 parcours ?',
            content:
              'Non, vous pouvez choisir moins de 10 parcours (1, 2, 3, etc.) mais plus vous choisissez de parcours, plus vous êtes susceptible d’augmenter votre cagnotte en Tickets E.Leclerc.',
          },
          {
            title: 'Comment maximiser mes gains avec les Parcours Gagnants ?',
            content:
              'Pour booster votre cagnotte, nous vous recommandons de sélectionner le maximum de parcours possibles (jusqu’à 10 !). Chaque produit acheté parmi vos marques sélectionnées vous rapproche du palier supérieur. Vous pouvez cumuler jusqu’à 50€ par opération : un vrai coup de pouce pour votre pouvoir d’achat !',
          },
          {
            title: 'Pourquoi un parcours n’est plus disponible ?',
            content:
              'Nos parcours sont victimes de leur succès ! Si la limite du nombre de parcours disponibles a été atteinte, le parcours devient indisponible et vous ne pourrez plus le sélectionner. Un parcours peut redevenir disponible si vous le desélectionnez.',
          },
          {
            title:
              'Comment sont sélectionnées les marques qui me sont proposées ?',
            content:
              'Les parcours sont personnalisés en fonction de vos habitudes d’achat effectués avec présentation de votre Carte de fidélité. Cela vous permet de retrouver vos produits préférés ou de faire de jolies découvertes à chaque nouvelle opération.',
          },
          {
            title:
              'Dois-je respecter un montant minimum d’achat lors de mes achats en magasin, en Drive ou en Livraison à domicile ?',
            content:
              'Il n’y a pas de montant minimum d’achat à effectuer. Chaque euro dépensé sur vos produits des parcours sélectionnés compte, que vous fassiez un gros plein de course ou un petit achat d’appoint. Pensez simplement à bien présenter votre Carte E.Leclerc !',
          },
          {
            title: 'Est-ce que je peux changer de parcours ?',
            content:
              'Vous pouvez changer de parcours seulement jusqu’à votre premier passage en caisse ou votre première commande en ligne. Une fois que vous avez commencé à cumuler des achats sur l’un de vos parcours, vous ne pouvez plus le modifier.',
          },
          {
            title:
              'J’ai oublié de présenter ma Carte E.Leclerc lors de mes achats. Mes achats seront-ils pris en compte dans le calcul de ma cagnotte ?',
            content:
              'Non. Il est impératif de présenter votre Carte E.Leclerc afin que vos achats soient comptabilisés dans les parcours gagnants. Pensez à télécharger <a href="https://www.e.leclerc/e/mon-eleclerc-telechargement?srsltid=AfmBOooYXelGWEj3mBToqrpOn3vP0SmbJEA9O3wbpulrCSpwSMC2pD4D" target="_blank">l’application Mon E.Leclerc</a> pour avoir toujours votre carte de fidélité avec vous.',
          },
          {
            title:
              'J’ai continué à acheter des produits d’un parcours alors que j’ai atteint le palier maximum, est-ce que ces achats sont-ils pris en compte ?',
            content:
              'Si vous atteignez le palier maximal sur un parcours, vos achats supplémentaires de produits ne vous permettront pas de cumuler de nouveaux Tickets E.Leclerc sur ce même parcours. Le cumul de gains de tous vos parcours vous permet d’obtenir une cagnotte maximale de 50€ en Tickets E.Leclerc.',
          },
          {
            title:
              'Combien de Tickets E.Leclerc puis-je cumuler au maximum pour une opération ?',
            content:
              'Le montant de Tickets E.Leclerc que vous pouvez cumuler dépend des Parcours Gagnants personnalisés qui vous sont proposés. Ce montant peut atteindre au maximum 50€.',
          },
          {
            title:
              'Puis-je cumuler mes achats entre différents magasins E.Leclerc ou Drive ?',
            content:
              'Oui, tous vos achats effectués en magasin ou Drive comptent, tant que vous présentez votre Carte E.Leclerc à chaque passage en caisse ou commande Drive.',
          },
          {
            title:
              'Puis-je cumuler mes achats entre plusieurs Cartes de fidélité ?',
            content:
              'Non, vos parcours sont déterminés sur la base des achats associés à une seule Carte de fidélité et seuls les achats effectués avec présentation de cette Carte sont pris en compte.',
          },
          {
            title: 'Comment se calcule ma cagnotte Parcours Gagnants ?',
            content:
              'En achetant des produits de vos marques préférées, vous faites progresser vos parcours. A chaque palier gagné, vous cumulez des Tickets E.Leclerc sur votre cagnotte pour un montant maximal de 50€.',
          },
          {
            title: 'Comment savoir où j’en suis sur mes différents parcours ?',
            content:
              'Votre page personnelle Parcours Gagnants est mise à jour sous un délai maximum de 3 jours après chaque achat.</br>La progression de vos parcours jusqu’à la fin de l’opération est visible sur votre page personnelle Parcours Gagnants, grâce à une barre de progression sur la ou les marques que vous avez sélectionnées.<br/></br>La dernière date à laquelle vos achats ont été mis à jour est indiquée sur votre Parcours.',
          },
          {
            title: 'Comment puis-je accéder à mes Parcours Gagnants ?',
            content:
              'Vous avez plusieurs possibilités pour accéder à vos Parcours Gagnants E.Leclerc :<br/></br>depuis l’email reçu dans votre boîte email (n’hésitez pas à vérifier dans vos courriers indésirables) en vous connectant à votre compte E.Leclerc, soit depuis le site <a href="https://www.e.leclerc/" target="_blank">www.eleclerc</a>, ou depuis les sites <a href="https://www.leclercdrive.fr/" target="_blank">www.leclercdrive.fr</a> depuis les applications mobiles E.Leclerc : Mon E.Leclerc, LeclercDrive',
          },
          {
            title: 'Puis-je cumuler mes parcours avec d’autres réductions ?',
            content:
              'Bonne nouvelle, les Parcours Gagnants sont cumulables avec d’autres promotions en cours. C’est le montant final payé (après remise) qui sera ajouté à votre compteur de parcours. C’est le moment de cumuler les bonnes affaires !</br>N’hésitez pas à vous connecter à votre compte pour voir les promotions actuellement disponibles : <a href="https://www.e.leclerc/auth" target="_blank">https://www.e.leclerc/auth</a> A noter que les produits avec une offre de réduction ’Zéro Gaspi’ ainsi que les produits à poids variables ne sont pas comptabilisés dans l’avancement du compteur du parcours.',
          },
          {
            title: 'Quand est-ce que ma cagnotte sera versée ?',
            content:
              'Le montant que vous avez cagnotté durant l’opération est versé sous forme de Tickets E.Leclerc sur votre Carte E.Leclerc, au plus tard 15 jours après la clôture de l’opération.</br> Si vous avez communiqué votre email ainsi que l’autorisation d’en recevoir, vous serez informé dès lors que vos Tickets E.Leclerc Parcours Gagnants seront bien crédités sur votre Carte E.Leclerc.',
          },
          {
            title:
              'Comment puis-je consulter le montant de Tickets E.Leclerc crédité sur ma Carte de fidélité dans le cadre des Parcours Gagnants ?',
            content:
              'La consultation du montant des Tickets E.Leclerc gagnés dans le cadre d’une opération Parcours Gagnants est disponible directement sur le site <a href="https://parcours-gagnants.leclerc/fr/login" target="_blank">www.parcours-gagnants.leclerc</a> Les participants ayant accepté de recevoir les offres commerciales par email de la part de l’enseigne, reçoivent également l’information par :</br><ul><li>Un email le jour de fin de l’opération avec le montant des Tickets E.Leclerc cumulés dans le cadre de l’opération.</li><li>Un autre email lorsque le crédit a été effectué sur la Carte E.Leclerc</li><li>Les participants ayant l’application Mon E.Leclerc peuvent visualiser leur solde de Tickets E.Leclerc Parcours Gagnants dès lors qu’ils ont été crédités. L’information est présente sur votre application dans dans la rubrique “ Ma cagnotte Tickets E.Leclerc”.</li><li>L’information est également disponible sur demande à l’accueil de votre magasin lorsque les Tickets E.Leclerc cumulés ont été crédités sur la Carte E.Leclerc 15 jours après la date de fin de l’opération.</li></ul>',
          },
          {
            title:
              'Quand et comment puis-je consulter les prochains Parcours Gagnants ?',
            content:
              'Vous pouvez consulter les prochains parcours 2-3 jours avant qu’ils ne débutent, via l’onglet « Prochainement » directement sur le site www.parcours-gagnants.leclerc.',
          },
          {
            title:
              'Pourquoi est-ce que je ne retrouve pas les mêmes parcours entre deux opérations ?',
            content:
              'Les parcours qui vous sont proposés sont définis pour chaque opération en fonction de vos achats et des marques partenaires du moment. Les parcours peuvent donc évoluer d’une opération à l’autre.',
          },
          {
            title:
              'Pourquoi est-ce que je ne peux pas jouer alors que je remplis toutes les conditions ?',
            content:
              'Afin de participer, il faut que vous remplissiez les conditions suivantes :</br></br>Être détenteur de la Carte de fidélité E.Leclerc et l’avoir rattachée dans votre compte sur les sites E.Leclerc, Drive E.Leclerc ou dans les applications mobiles Mon E.Leclerc, Drive E.Leclerc. Avoir renseigné votre magasin préféré de France Métropolitaine ou de Corse dans votre compte client sur les sites E.Leclerc, Drive E.Leclerc.</br>Avoir donné votre accord pour que l’enseigne E.Leclerc(1) vous fasse profiter d’offres et d’avantages qui correspondent à vos achats et vos envies(2). Pour donner votre accord, rendez-vous dans votre compte client sur les sites E.Leclerc, Drive E.Leclerc ou dans les applications mobiles Mon E.Leclerc ou Drive E.Leclerc.',
          },
          {
            title:
              'Je ne trouve pas tous les produits éligibles au parcours dans mon magasin ?',
            content:
              'Certains magasins ou drives peuvent ne pas détenir forcément toutes les références éligibles au parcours pour plusieurs raisons possibles (ex : difficulté d’approvisionnement ponctuelle, rupture temporaire, liberté de référencement du magasin, etc).',
          },
        ],
        accordion: {
          styles: {
            title: {
              color: '#003494',
              fontFamily: 'var(--font-family-medium)',
              fontSize: '16px',
              padding: '10px 0',
            },
            description: {
              fontSize: '14px',
              color: '#747474',
              padding: '10px 10px',
              fontFamily: 'var(--font-family-light)',
              lineHeight: '23px',
            },
          },
          iconMore: 'assets/images/chondrus/expand-more.svg',
          iconLess: 'assets/images/chondrus/expand-less.svg',
          alternativeTextExpandMore: 'Réduire la section',
          alternativeTextExpandLess: 'Développer la section',
        },
      },
      contactUs: {
        type: ContactUsType.FORM,
        config: {
          variant: Variants.VARIANT_1,
          title: {
            color: '#003494',
            fontFamily: 'var(--font-family-medium)',
            text: 'Contactez-nous',
          },
          subtitle: {
            color: '#003494',
            text: 'Vous n’avez pas trouvé la réponse à votre question ?',
            fontFamily: 'var(--font-family-light)',
          },
          contactFormBlock: {
            description: {
              color: 'white',
              fontFamily: 'var(--font-family-roboto-light)',
              text: 'Merci de ne pas indiquer de données personnelles dans votre message.\nUne réponse vous sera apportée par mail par notre Service Client AlloLeclerc.',
            },
            fields: [
              {
                type: 'text',
                label: 'Votre mail*',
                formControlName: 'email',
                required: true,
                placeholder: 'Exemple : client@gmail.com',
                autoComplete: 'email',
                labelStyles: {
                  color: 'white',
                  textAlign: 'left',
                  fontFamily: 'var(--font-family-light)',
                },
                validations: [
                  {
                    type: 'required',
                    message: "Merci de vérifier que l'adresse est bien valide.",
                  },
                  {
                    type: 'pattern',
                    message: "Merci de vérifier que l'adresse est bien valide.",
                    pattern:
                      "^[a-zA-Z0-9_!#$%&'*+/=?`{|}~^.-]+@[a-zA-Z0-9.-]+.[a-zA-Z]{2,}$",
                  },
                ],
                errorStyles: {
                  width: 'auto',
                  color: '#555555',
                  textAlign: 'center',
                  borderRadius: '20px',
                  background: 'white',
                  padding: '.5rem 1rem',
                  display: 'inline-block',
                },
              },
              {
                type: 'select',
                required: true,
                validations: [
                  {
                    type: 'required',
                    message: 'Veuillez renseigner ce champ',
                  },
                ],
                defaultValue: '',
                formControlName: 'type',
                label: 'Votre question concerne ?*',
                placeholder: 'Choisir une option',
                labelStyles: {
                  color: 'white',
                  textAlign: 'left',
                  fontFamily: 'var(--font-family-light)',
                },
                options: [
                  {
                    value: 'parcours-gagnants',
                    label: 'Parcours Gagnants',
                  },
                  {
                    value: 'parcours-bonus-plus',
                    label: 'Parcours Bonus+',
                  },
                ],
              },
              {
                type: 'select',
                required: true,
                validations: [
                  {
                    type: 'required',
                    message: 'Veuillez renseigner ce champ',
                  },
                ],
                defaultValue: '',
                formControlName: 'issue_types',
                placeholder: 'Choisir une option',
                label: 'Quel est votre problème ?*',
                labelStyles: {
                  color: 'white',
                  textAlign: 'left',
                  fontFamily: 'var(--font-family-light)',
                },
                options: [
                  {
                    value: 'participation',
                    label: 'Je ne peux pas participer aux Parcours Gagnants',
                  },
                  {
                    value: 'parcours',
                    label: 'Mes Parcours n’ont pas avancé',
                  },
                  {
                    value: 'tickets',
                    label: ' Mes Tickets E.Leclerc n’ont pas été cumulés',
                  },
                  {
                    value: 'autre',
                    label: 'Autre',
                  },
                ],
              },
            ],
            textAreaLabel: 'Message',
            submitButton: {
              label: 'Envoyer le message',
              iconUrl: 'assets/images/chondrus/arrow-right-navy.svg',
            },
          },
        },
      },
      templateAfterForm: [
        '<div style="padding-top: 2rem;max-width: 1130px; margin: 3rem auto; padding: 0 8vw;">',
        '<h1 style="font-size: 40px;color: #003494; font-family: var(--font-family-bold); padding: 30px 0px;text-align:center">Conditions Générales d‘Utilisation</h1>',
        '<h2 style="font-size: 14px; color:#747474;padding-top: 20px; font-family: var(--font-family-medium);text-decoration: underline; margin:0;">I. Mentions légales</h2>',
        '<p style="font-size: 14px;color:#747474; line-height: 20px; font-family: var(--font-family-normal);">Le site « www.parcours-gagnants.leclerc » (ci-après le "Site") est édité par le GALEC (Groupements d’Achats des Centres E.LECLERC, ci-après "l’Editeur"), société coopérative à capital variable dont le siège social est situé au 26 Quai Marcel Boyer 94200 Ivry-sur-Seine, immatriculée au Registre du Commerce et des sociétés de Créteil sous le numéro B 642 007 991.<br/>Siret Galec : 642.007.991.000.69 <br/>TVA Galec : FR 366.420.07.991 <br/>Directeur de Publication du site : Davy Saint-Laurent. <br/>Le Site et les données traitées dans le cadre de son édition sont hébergées sur une infrastructure Google Cloud Platform située en Union européenne et mise à la disposition de la société UntieNots (siège social : 5 rue Saint-Germain l’Auxerrois, 75001 Paris, France) – agissant en tant que sous-traitant de le GALEC – par la société Google Cloud EMEA Limited (adresse : 70 Sir John Rogerson’s Quay, Dublin 2, Irlande ; tél. : +33 (0)8 05 98 03 18).</p>',
        '<h2 style="font-size: 14px; color:#747474; font-family: var(--font-family-medium);text-decoration: underline; margin:0;padding-top:10px;">II. Conditions générales d’utilisation</h2>',
        '<p style="font-size: 14px;color:#747474; line-height: 20px; font-family: var(--font-family-normal);">Les présentes Conditions générales d’utilisation du site ont pour objet de fixer les conditions d’accès et d’utilisation des services proposés sur le Site. L’Utilisateur désigne la personne qui se rend sur le Site www.parcours-gagnants.leclerc. Les termes « vous » ou « vos » font référence à vous en tant qu’Utilisateur du Site.</p>',
        '<h3 style="font-size: 14px; color:#747474; font-family: var(--font-family-medium);margin-bottom:20px; line-height: 20px;padding-top:10px;">ARTICLE 1.<br/> SERVICE PROPOSÉ</h3>',
        '<p style="font-size: 14px;color:#747474; line-height: 20px; font-family: var(--font-family-normal);">Le service est proposé à des clients ayant une carte de fidélité E.Leclerc et résidants en France Métropolitaine. Il donne un accès privilégié à 20 parcours parmi lesquels chaque client participant pourra en sélectionner 10 au maximum en fonction de ses préférences. Le jeu se déroule du 1er janvier au 31 décembre 2026, en plusieurs opérations de 4 ou 6 semaines. Les dates exactes de chaque opération figurent dans les mails qui seront envoyés aux clients pour participer et sur leur page personnelle Parcours Gagnants.<br/>En achetant ses produits préférés sur <a target="_blank" href="https://www.leclercdrive.fr/" aria-label="Accéder au site www.leclercdrive.fr" title="Accéder au site www.leclercdrive.fr">www.leclercdrive.fr,</a> ou en magasin, le client fait progresser ses parcours. Au fur et à mesure de sa progression, il accède à des paliers qui lui permettent de cumuler desTickets E.Leclerc qui lui seront reversés 15 jours après la fin d’une opération. Les parcours sont cumulables avec toutes les offres en cours. <br/>Pour suivre l’avancement de ses parcours, le client doit se rendre sur sa page personnelle, accessible depuis:<br/></p>',
        '<ul style="font-size: 14px;color:#747474; line-height: 20px;font-family: var(--font-family-normal);"><li>l’email envoyé directement dans sa boite email</li><li>son compte E.Leclerc sur les sites <a target="_blank" href="https://www.e.leclerc/" aria-label="Accéder au site www.e.leclerc" title="Accéder au site www.e.leclerc">www.e.leclerc,</a> <a target="_blank" href="https://www.leclercdrive.fr/" aria-label="Accéder au site www.leclercdrive.fr" title="Accéder au site www.leclercdrive.fr">www.leclercdrive.fr </a></li> <li>les applications mobiles E.Leclerc : Mon E.Leclerc, LeclercDrive.</li> </ul>',
        '<p style="font-size: 14px;color:#747474; line-height: 20px; font-family: var(--font-family-normal);">Cette page personnelle est mise à jour au plus tard 3 jours après ses achats. La date de dernière mise à jour y est indiquée. <br/> La sélection des parcours est faite par le titulaire de la carte qui a reçu le mail l’invitant à participer. Cependant, si plusieurs personnes utilisent la même carte de fidélité, tous les achats comptabilisés sur cette carte seront pris en compte, sous réserve qu’ils correspondent bien aux parcours sélectionnés.</p>',
        '<h3 style="font-size: 14px; color:#747474; font-family: var(--font-family-medium); margin-bottom:20px;padding-top:10px;line-height: 20px;">ARTICLE 2. <br/>ACCEPTATION DES CONDITIONS GÉNÉRALES D’UTILISATION DU SITE</h3>',
        '<p style="font-size: 14px; color:#747474; line-height: 20px; font-family: var(--font-family-normal);">Les présentes conditions sont destinées aux Utilisateurs du Site.<br/> L’Utilisateur est présumé connaître et accepter, sans réserve, l’ensemble des conditions d’utilisation du Site du seul fait de sa connexion au Site et de son utilisation des Services, quels que soient les terminaux numériques de réception utilisés. <br/>L’Utilisateur est invité à ne pas se connecter sur le Site, ni utiliser les Services s’il n’accepte pas tout ou partie des présentes.<br/>L’Editeur se réserve le droit de modifier les conditions générales d’utilisation du Site à tout moment, afin notamment de se conformer à toutes évolutions réglementaires, jurisprudentielles, éditoriales ou techniques.<br/>L’Utilisateur est expressément informé que la version en vigueur est celle qui est mise en ligne sur le Site, à la date de son accès à l’un quelconque des Services, ce que l’Utilisateur reconnaît et accepte sans restriction, s’engageant à s’y référer systématiquement lors de chaque connexion.<br/>Le Galec (Editeur du Service), en tant que société coopérative de commerçants détaillants en application de l’article L124-1 du code de commerce, a pour objet d’améliorer les conditions dans lesquelles ses coopérateurs exercent leur activité commerciale. En conséquence, le rôle du Galec se limite à mettre en œuvre une politique commerciale commune propre à assurer le développement et l’activité de ses associés, en l’occurrence afin d’assurer l’animation commerciale et l’engagement des clients auprès des magasins indépendants.<br/><br/>Le Galec est une partie tierce au contrat de vente conclu ultérieurement entre l’Utilisateur et le magasin.<br/><br/>Chaque magasin est notamment responsable de la mise en œuvre de sa participation au programme, du référencement proposé à ses clients, et de son stock de marchandises. Il est donc possible que l’intégralité des références éligibles à un parcours ne soit pas disponible dans le magasin visité par le client. </p>',
        '<h3 style="font-size: 14px; color:#747474; font-family: var(--font-family-medium); margin-bottom:20px; padding-top:10px;line-height: 20px;">ARTICLE 3.<br/> ACCÈS AUX SERVICES ET SUSPENSION DES SERVICES </h3>',
        '<p style="font-size: 14px; color:#747474; font-family: var(--font-family-light); line-height: 20px;"> 3.1 Disponibilité du Site</p>',
        '<p style="font-size: 14px; color:#747474; line-height: 20px; font-family: var(--font-family-normal); margin:0;">Le Galec, en tant que coopérative d’un mouvement de commerçants indépendants, a la capacité en vertu de l’article L.124-1 du Code de commerce de mettre en œuvre une politique commerciale commune propre à assurer le développement et l’activité de ses associés, ce qui lui permet notamment d’organiser des opérations commerciales tout en laissant aux magasins, sociétés indépendantes, leur liberté de gestion.<br/> L’Editeur s’engage à faire ses meilleurs efforts pour assurer que l’accès et le fonctionnement du Site soient assurés 24 heures sur 24 et 7 jours sur 7 sans interruption. Toutefois, l’Editeur ne peut voir sa responsabilité recherchée en cas d’indisponibilité temporaire du Site :</p>',
        '<p style="font-size: 14px; color:#747474; line-height: 22px; font-family: var(--font-family-normal);margin:0;">(i) en cas de maintenance du Site ou des serveurs sur lequel elle est hébergée, <br/> (ii) en cas de survenance d’événements extérieurs à sa volonté et à son contrôle <br/> (iii) en raison de cas de force majeure. L’Editeur informera au préalable l’Utilisateur de l’indisponibilité si l’événement à l’origine de l’indisponibilité est prévisible.</p>',
        '<h4 style="font-size: 14px; color:#747474; font-family: var(--font-family-light);margin:20px 0;">3.2 Suspension de l’accès</h4>',
        '<p style="font-size: 14px; color:#747474; line-height: 22px; font-family: var(--font-family-normal);margin:0;"> L’Editeur se réserve le droit de suspendre l’accès aux Services : <br/>(i) en cas d’utilisation non conforme aux dispositions des présentes,<br/>(ii) en cas d’opérations de maintenance. <br/>La responsabilité de l’Editeur ne peut être engagée en raison de ces interruptions et des conséquences qui peuvent en découler pour l’Utilisateur.</p>',
        '<h3 style="font-size: 14px; color:#747474; font-family: var(--font-family-medium);margin:20px 0; padding-top:10px;line-height: 20px;">ARTICLE 4.<br/> PROPRIÉTÉ INTELLECTUELLE</h3>',
        '<p style="font-size: 14px; color:#747474; line-height: 22px; font-family: var(--font-family-normal);margin:0;">Le contenu du Site et l’utilisation des Services sont protégés par la loi et notamment les dispositions du Code de propriété intellectuelle et sont exclusivement destinés à l’information et l’usage personnel de l’Utilisateur qui bénéficie d’un droit d’usage privé, non collectif et non exclusif.<br/>Sauf autorisation expresse et préalable de l’Editeur, sont interdites toutes reproduction, représentation et utilisation autres que celles visées ci-dessus et notamment:</p>',
        '<p style="font-size: 14px; color:#747474; line-height: 22px; font-family: var(--font-family-normal);margin:0;">(i) toute adaptation, mise à disposition du public à sa demande ou non, distribution, rediffusion sous quelque forme que ce soit, mise en réseau, communication publique de tout ou partie des œuvres, prestations, marques et tout éléments protégés ou susceptibles de protection par le droit de la propriété intellectuelle reproduits sur le Site;<br/>(ii) toute extraction ou réutilisation, y compris à des fins privées, d’une partie substantielle du contenu des bases de données constituées par le Site;<br/>(iii) toute extraction ou réutilisation, répétée et systématique, y compris à des fins privées, d’une partie même non substantielle du contenu des bases de données constituées par le Site;<br/>(iv) tout lien, accès, modification, ajout, suppression qui porte sur le système de traitement automatisé de l’édition en ligne et modifie les conditions de publication ou la politique éditoriale. </p>',
        '<p style="font-size: 14px; color:#747474; line-height: 22px; font-family: var(--font-family-normal);margin:0;">La marque et tout autre élément protégeable au titre de la propriété intellectuelle appartenant à l’Editeur, constituent des signes distinctifs. Sauf autorisation expresse et préalable, tout usage de ces signes distinctifs ainsi que tous autres signes distinctifs appartenant à l’Editeur ou à des tiers, expose l’Utilisateur à des poursuites pénales et/ou civiles.</p>',
        '<h3 style="font-size: 14px; color:#747474; font-family: var(--font-family-medium);margin-bottom:20px; padding-top:10px;line-height: 20px;">ARTICLE 5.<br/> POLITIQUE RELATIVE A LA PROTECTION DES DONNEES A CARACTERE PERSONNEL</h3>',
        '<p style="font-size: 14px; color:#747474; line-height: 22px; font-family: var--font-family-normal);margin:0;">Nous vous invitons à vous référer à la Charte de Protection des données à caractère personnel accessibles <a href="https://media.e.leclerc/LEN/document/Copie+de+20241217+Charte+de+protection+des+donn%C3%A9es+personnelles_carte+de+fid%C3%A9lit%C3%A9?vh=c5c974&func=proxy" target="_blank">ici</a></p>',
        '<h3 style="font-size: 14px; color:#747474; font-family: var(--font-family-medium);margin-bottom:20px; padding-top:10px;line-height: 20px;">ARTICLE 6.<br/> LOI APPLICABLE ET JUGE COMPETENT</h3>',
        '<p style="font-size: 14px; color:#747474; line-height: 22px; font-family: var(--font-family-normal);margin:0;">Le non-respect par l’Utilisateur, quelle que soit sa localisation, de l’une quelconque des dispositions des présentes et de façon plus générale toute difficulté touchant à son exécution, son interprétation ou sa validité, sont soumis à la loi Française et aux juridictions françaises.</p>',
      ],
      templateAfterContactForm: [
        '<div style="padding-top: 2rem;max-width: 1130px; margin: 3rem auto; padding: 0 8vw;">',
        '<h3 style="font-size: 40px; line-height: normal; color: #003494; margin: 0 0 40px; font-family: var(--font-family-medium); text-align: center; text-transform: uppercase;">Quelles Sont Les Conditions Pour Participer ?</h3>',
        '<div style="display: flex; flex-direction: column; gap: 16px; margin-bottom: 40px;">',
        '<div style="display: flex; align-items: center; gap: 24px; padding: 32px 0; border-bottom: 1px solid rgba(116, 116, 116, 0.2);">',
        '<span style="flex-shrink: 0; color: #003494; font-size: 50px; line-height: normal; font-family: var(--font-family-bold);">1</span>',
        '<p style="color: #003494; font-size: 16px; line-height: normal; font-family: var(--font-family-light); margin: 0;">Etre détenteur de la Carte de Fidélité E.Leclerc et l’avoir rattachée dans votre compte client sur les sites E.leclerc, Drive E.Leclerc ou dans les applications mobiles Mon E.leclerc ou LeclercDrive.</p>',
        '</div>',
        '<div style="display: flex; align-items: center; gap: 24px; padding: 32px 0; border-bottom: 1px solid rgba(116, 116, 116, 0.2);">',
        '<span style="flex-shrink: 0; color: #003494; font-size: 50px; line-height: normal; font-family: var(--font-family-bold);">2</span>',
        '<p style="color: #003494; font-size: 16px; line-height: normal; font-family: var(--font-family-light); margin: 0;">Avoir renseigné votre magasin préféré dans votre compte Carte E.Leclerc (magasin de France Métropolitaine ou de Corse) dans votre compte client sur le sites E.Leclerc, Drive E.Leclerc.</p>',
        '</div>',
        '<div style="display: flex; align-items: center; gap: 24px; padding: 32px 0; border-bottom: 1px solid rgba(116, 116, 116, 0.2);">',
        '<span style="flex-shrink: 0; color: #003494; font-size: 50px; line-height: normal; font-family: var(--font-family-bold);">3</span>',
        '<p style="color: #003494; font-size: 16px; line-height: normal; font-family: var(--font-family-light); margin: 0;">Avoir donné votre accord pour que l’enseigne E.Leclerc(1) vous fasse profiter d’offres et d’avantages qui correspondent à vos achats et vos envies(2). Pour donner votre accord, rendez-vous dans votre compte client sur les sites E.Leclerc, Drive E.Leclerc ou dans les applications mobiles Mon E.Leclerc ou Drive E.Leclerc.</p>',
        '</div>',
        '<p style="color: #747474; margin: 0 0 20px; line-height: 21px; font-size: 14px; font-family: var(--font-family-normal);">Si vous souhaitez participer, ne tardez pas à remplir les conditions. En fonction de la date à laquelle vous aurez rempli les conditions de participation ci-dessus, il est possible que vous ne puissiez pas participer aux Parcours Gagnants en cours mais vous pourrez participer aux prochains. Un email vous y invitera.</p>',
        '<p style="color: #747474;font-family: var(--font-family-normal);margin-bottom: 10px;font-size: 14px;">(1) Quelles sont les sociétés de l’enseigne E.Leclerc ?</p>',
        '<p style="color: #747474;font-family: var(--font-family-normal);margin-bottom: 10px;font-size: 14px;">Votre adresse email et/ou votre numéro de téléphone mobile seront transmis uniquement aux sociétés de l’enseigne E.Leclerc. Vous pourrez recevoir des emails et/ou des sms de la part de :</p>',
        '<ul style="color: #747474;font-family: var(--font-family-normal);font-size: 14px;margin: 0;"><li>Votre magasin E.Leclerc et ses magasins spécialisés (parapharmacie, optique, l’auto, station-service, drive, animalerie, brico, jardi, jouet, le manège à bijoux, une heure pour soi, espace culturel, location, sport, voyages, occasion),</li> </ul>',
        '<ul style="color:#747474;font-family: var(--font-family-normal);font-size: 14px;margin: 0;"><li>La société L-Commerce, qui édite les sites E.Leclerc, maisonetloisirs.leclerc, optique.leclerc, photo.leclerc, e-librairie.leclerc, auto.leclerc,</li> </ul>',
        '<ul style="color: #747474;font-family: var(--font-family-normal);font-size: 14px;margin: 0;"><li>Le Groupement d’Achat des Centres E.Leclerc (SC GALEC) qui réalise la communication commerciale E.Leclerc,</li> </ul>',
        '<ul style="color: #747474;font-family: var(--font-family-normal);font-size: 14px;margin: 0;"><li>Les sociétés qui gèrent la livraison à domicile ou en point relais,</li> </ul>',
        '<ul style="color: #747474;font-family: var(--font-family-normal);font-size: 14px;margin: 0;"><li>La société E.Leclerc Voyages qui édite le site <a target="_blank" href="https://www.leclercvoyages.com/" aria-label="Accéder au site leclercvoyages.com" title="Accéder au site leclercvoyages.com">leclercvoyages.com,</a></li> </ul>',
        '<ul style="color: #747474;font-family: var(--font-family-normal);font-size: 14px;margin: 0;"><li>La société Siplec spécialisée dans les métiers de l’énergie et dans l’approvisionnement de produits manufacturés pour l’enseigne E.Leclerc et l’édition des sites primes-energie.leclerc, energies.leclerc et cartecarburant.leclerc, sous la marque E.LECLERC ENERGIES,</li> </ul>',
        '<ul style="color: #747474;font-family: var(--font-family-normal);font-size: 14px;margin: 0;"><li>La société Devinlec qui édite le site <a target="_blank"href="https://www.lemanegeabijoux.com/" aria-label="Accéder au site lemanegeabijoux.com" title="Accéder au site lemanegeabijoux.com">lemanegeabijoux.com,</a></li> </ul>',
        '<ul style="color: #747474;font-family: var(--font-family-normal);font-size: 14px;margin: 0;"><li>La Banque Edel qui participe notamment à la gestion des cartes cadeau E.Leclerc, des cartes de crédit REGLO finance et des produits d’assurance Garantie Remboursement Intégral,</li> </ul>',
        '<ul style="color: #747474;font-family: var(--font-family-normal);font-size: 14px;margin: 0;"><li>La société L Telecom qui édite le site <a target="_blank"href="https://reglomobile.fr/" aria-label="Accéder au site reglomobile.fr" title="Accéder au site reglomobile.fr">reglomobile.fr,</a></li> </ul>',
        '<ul style="color: #747474;font-family: var(--font-family-normal);font-size: 14px;margin: 0;"><li>La société Conso Régie qui est la régie publicitaire de l’enseigne E.Leclerc et met en ligne des publicités pour l’enseigne E.Leclerc.</li> </ul>',
        '<p style="color: #747474;margin: 10px 0;font-family: var(--font-family-normal);font-size: 14px;">(2) Comment sont adaptées les offres E.Leclerc en fonction de mes achats et mes envies ?</p>',
        '<p style="color: #747474;margin:0;font-family: var(--font-family-normal);font-size: 14px;>Un profilage est réalisé à partir de votre historique d’achats aux fins d’adapter les offres commerciales qui vous sont adressées. Ce profilages permet une segmentation des clients E.Leclerc, ainsi que la diffusion de manière automatisée d’offres commerciales personnalisées sur divers supports (ticket de caisse, courrier, distribution d’échantillons, bannière publicitaire sur internet et applications mobiles et, si vous avez consenti, par email et/ ou SMS, ou via votre enceinte "intelligente" si vous bénéficiez du service Assistant vocal E.Leclerc).<br/> Le profilage s’effectue par un suivi de vos achats dans chacun des circuits de distribution E.Leclerc, en considérant le contenu de votre panier d’achat. Ce suivi tient également compte de votre fidélité dans le temps.<br/>Les données utilisées pour le profilage sont celles que vous avez fournies directement et celles qui sont générées par vos habitudes d’achat au sein de l’enseigne E.Leclerc. </p>',
      ],
      templateBeforeChanges: [
        '<div style="max-width: 1130px; margin: 3rem auto;padding: 0 8vw;">',
        '<p style="color:#747474;margin: 0;font-family: var(--font-family-normal);font-size: 14px; line-height: 24px;">*Les Tickets E.Leclerc sont des bons d’achat réservés aux porteurs de la Carte E.Leclerc, sur présentation en caisse de la Carte E.Leclerc et valables dès le lendemain de leur obtention, cumulables sur la Carte E.Leclerc et utilisables sur tous les produits de l’ensemble des centres E.Leclerc participant au programme de fidélité hors carburants. Les offres bénéficiant d’un Ticket E.Leclerc sont limitées à 15 produits par foyer par opération. Carte E.Leclerc 100% gratuite et disponible immédiatement. Offre en Ticket E.Leclerc non cumulable avec des produits de la même gamme bénéficiant d’un autre “Ticket E.Leclerc” ou d’une autre promotion.</p>',
        '<p style="color:#747474;margin: 0;font-family: var(--font-family-normal);font-size: 14px; line-height: 24px;">Les informations recueillies lors de l’adhésion au programme Carte de fidélité E.Leclerc sont utilisées pour le traitement et la gestion de ce programme. Elles sont conservées pendant vingt-quatre mois à compter de la dernière prise de contact émanant de l’utilisateur ou utilisation de la Carte de fidélité E.Leclerc.</p>',
        '<p style="color:#747474;margin: 0;font-family: var(--font-family-normal);font-size: 14px; line-height: 24px;">Le montant de Tickets E.Leclerc que vous pouvez cumuler dans le cadre des Parcours Gagnants dépend des parcours personnalisés qui vous sont proposés. Ce montant peut atteindre au maximum 50 €.</p>',
        '<p style="color:#747474;margin: 0;font-family: var(--font-family-normal);font-size: 14px; line-height: 24px;">Les Tickets E.Leclerc cumulés dans le cadre des Parcours Gagnants seront crédités sur votre Carte E.Leclerc dans un délai de 15 jours à partir de la date de fin de chaque opération.</p>',
        '</div>',
        '<div style="padding: 1vw 8vw;">',
        '<p style="color:#747474;margin: 0;font-family: var(--font-family-normal);font-size: 12px; line-height: 20px;">Ce site est protégé par reCAPTCHA, et la <a href="https://policies.google.com/privacy" title=”Politique de confidentialité”>Politique de confidentialité</a> ainsi que les <a href="https://policies.google.com/terms" title=”Conditions d’utilisation">Conditions d’utilisation</a> de Google s’appliquent.</p>',
        '</div>',
      ],
      loyaltychallengeBis: {
        afterTitle: true,
        questions: [
          {
            title: 'Quelles sont les conditions de participation ?',
            content:
              'Le service est proposé à tout client titulaire d’ une Carte E.Leclerc rattachée à un magasin préféré physique situé en France Métropolitaine ou en Corse tel qu’indiqué dans son compte Carte E.Leclerc. Le renseignement du magasin préféré peut également s’effectuer depuis le compte E.Leclerc sur les sites www.e.leclerc, www.leclercdrive.fr ou depuis les applications mobiles suivantes: Mon E.Leclerc, Leclerc Drive.',
          },
          {
            title: 'Combien de temps durent les Parcours Bonus + E.Leclerc ?',
            content:
              'Les Parcours Bonus + E.Leclerc durent du 1er Janvier au 31 décembre. Ils sont mis en place en plusieurs opérations de 2 mois. Les dates exactes de chaque opération figurent dans les mails qui vous seront envoyés pour participer et sur la page de jeux',
          },
          {
            title: 'Dois-je sélectionner un ou les parcours pour jouer ?',
            content:
              'Oui, vous pouvez choisir 1 ou tous les Parcours Bonus + pour jouer. Plus vous sélectionnez des Parcours Bonus +, plus vous êtes susceptible d’augmenter votre cagnotte en Tickets E.Leclerc.',
          },
          {
            title: 'Pourquoi un Parcours Bonus + n’est plus disponible ?',
            content:
              'Nos parcours sont victimes de leur succès ! Si la limite du nombre de Parcours Bonus + disponibles a été atteinte, le parcours devient indisponible et vous ne pourrez plus le sélectionner.',
          },
          {
            title:
              'Dois-je respecter un montant minimum d’achat lors de mes achats en magasin ou en Drive ?',
            content:
              'Il n’y a pas de montant minimum d’achat à effectuer. Chaque euro dépensé sur vos produits des parcours sélectionnés compte. Pensez simplement à bien présenter votre Carte E.Leclerc !',
          },
          {
            title:
              'J’ai oublié de présenter ma carte de fidélité lors de mes achats. Mes achats seront-ils pris en compte dans le calcul de ma cagnotte ?',
            content:
              'Non. Il est impératif de présenter votre Carte E.Leclerc afin que vos achats soient comptabilisés pour l’avancement de vos Parcours Bonus +. Pensez à télécharger <a href="https://www.e.leclerc/e/mon-eleclerc-telechargement?srsltid=AfmBOooYXelGWEj3mBToqrpOn3vP0SmbJEA9O3wbpulrCSpwSMC2pD4D" target="_blank">l’application Mon E.Leclerc</a> pour avoir toujours votre carte de fidélité avec vous',
          },
          {
            title:
              'J’ai continué à acheter des produits d’un Parcours Bonus + alors que j’ai atteint le palier maximum, est-ce que ces achats sont-ils pris en compte ?',
            content:
              'Si vous atteignez le palier maximal sur un Parcours Bonus +, vos achats supplémentaires de produits ne vous permettront pas de cumuler de nouveaux Tickets E.Leclerc sur ce même parcours',
          },
          {
            title:
              'Combien de Tickets E.Leclerc puis-je cumuler au maximum pour une opération Parcours Bonus + ?',
            content:
              'Le montant de Tickets E.Leclerc que vous pouvez cumuler dépend des Parcours Bonus + que vous avez sélectionné et atteint.',
          },
          {
            title:
              'Puis-je cumuler mes achats entre différents magasins E.Leclerc ?',
            content:
              'Oui, tous vos achats effectués en magasin, Drive situés en France Métropolitaine ou Corse comptent, tant que vous présentez votre Carte E.Leclerc à chaque passage en caisse.',
          },
          {
            title:
              'Puis-je cumuler mes achats entre plusieurs cartes de fidélité ?',
            content:
              'Non, vos Parcours Bonus + sont associés à une seule Carte de fidélité et seuls les achats effectués avec présentation de cette Carte sont pris en compte.',
          },
          {
            title: 'Comment se calcule ma cagnotte Parcours Bonus + ?',
            content:
              'En achetant des produits des marques que vous avez sélectionnés dans le cadre de vos Parcours Bonus +, vous faites progresser votre cagnotte. A chaque palier gagné, vous cumulez des Tickets E.Leclerc sur votre cagnotte.',
          },
          {
            title:
              'Comment savoir où j’en suis sur mes différents Parcours Bonus + ?',
            content:
              'Votre page personnelle Parcours Bonus + est mise à jour sous un délai maximum de 3 jours après chaque achat.</br>La progression de vos parcours jusqu’à la fin de l’opération est visible sur votre page personnelle Parcours Bonus +, grâce à une barre de progression sur le ou les parcours que vous avez sélectionnés.</br></br>La dernière date à laquelle vos achats ont été mis à jour est indiquée sur votre Parcours',
          },
          {
            title:
              'Puis-je cumuler mes Parcours Bonus + avec d’autres réductions ?',
            content:
              'Bonne nouvelle, les Parcours Bonus + sont cumulables avec d’autres promotions en cours. C’est le montant final payé (après remise) qui sera ajouté à votre compteur de parcours. C’est le moment de cumuler les bonnes affaires !',
          },
          {
            title: 'Quand est-ce que ma cagnotte sera versée ?',
            content:
              'Le montant que vous avez cagnotté durant l’opération est versé sous forme de Tickets E.Leclerc sur votre Carte E.Leclerc, au plus tard 15 jours après la clôture de l’opération.</br>Si vous avez communiqué votre email ainsi que l’autorisation d’en recevoir, vous serez informé dès lors que vos Tickets E.Leclerc Parcours Bonus + seront bien crédités sur votre Carte E.Leclerc.',
          },
          {
            title:
              'Comment puis-je consulter le montant de Tickets E.Leclerc crédité sur ma Carte de fidélité dans le cadre des Parcours Bonus + ?',
            content:
              'Le montant des Tickets E.Leclerc gagnés dans le cadre d’une opération Parcours Gagnants est consultable directement sur le site <a href="https://parcours-gagnants.leclerc/fr/login" target="_blank" >www.parcours-gagnants.leclerc</a></br>Les participants ayant accepté de recevoir les offres commerciales par email de la part de l’enseigne, reçoivent également l’information par :<ul><li>Un email le jour de fin de l’opération avec le montant des Tickets E.Leclerc cumulés dans le cadre de l’opération.</li><li>Un autre email lorsque le crédit a été effectué sur la Carte E.Leclerc</li><li>Les participants ayant l’application Mon E.Leclerc peuvent visualiser leur solde de Tickets E.Leclerc Parcours Gagnants dès lors qu’ils ont été crédités. L’information est présente sur votre application dans dans la rubrique “Ma cagnotte Tickets E.Leclerc”</li><li>L’information est également disponible sur demande à l’accueil de votre magasin lorsque les Tickets E.Leclerc cumulés ont été crédités sur la Carte E.Leclerc 15 jours après la date de fin de l’opération</li></ul>',
          },
          {
            title:
              'Pourquoi est-ce que je ne peux pas jouer alors que je remplis toutes les conditions ?',
            content:
              'Afin de participer aux Parcours Bonus +, il faut que vous remplissiez les conditions suivantes :<ul><li>Être détenteur de la Carte de fidélité E.Leclerc et l’avoir rattachée dans votre compte client sur les sites E.Leclerc, Drive E.Leclerc ou dans les applications mobiles Mon E.Leclerc, Drive E.Leclerc.</li><li>Avoir renseigné votre magasin préféré dans votre compte Carte E.Leclerc (magasin de France Métropolitaine ou de Corse) dans votre compte client sur les sites E.Leclerc, Drive E.Leclerc.</li></ul>',
          },
          {
            title:
              'Je ne trouve pas tous les produits éligibles au parcours dans mon magasin ?',
            content:
              'Certains magasins ou drives peuvent ne pas détenir toutes les références éligibles au parcours pour plusieurs raisons possibles (ex : difficulté d’approvisionnement ponctuelle, rupture temporaire, liberté de référencement du magasin, etc).',
          },
        ],
        showContactForm: true,
        templateAfterContactForm: [
          '<div style="padding-top: 2rem;max-width: 1130px; margin: 3rem auto; padding: 0 8vw;">',
          '<h3 style="font-size: 40px; line-height: normal; color: #003494; margin: 0 0 40px; font-family: var(--font-family-medium); text-align: center; text-transform: uppercase;">Quelles Sont Les Conditions Pour Participer ?</h3>',
          '<div style="display: flex; flex-direction: column; gap: 16px; margin-bottom: 40px;">',
          '<div style="display: flex; align-items: center; gap: 24px; padding: 32px 0; border-bottom: 1px solid rgba(116, 116, 116, 0.2);">',
          '<span style="flex-shrink: 0; color: #003494; font-size: 50px; line-height: normal; font-family: var(--font-family-bold);">1</span>',
          '<p style="color: #003494; font-size: 16px; line-height: normal; font-family: var(--font-family-light); margin: 0;">Etre détenteur de la Carte de Fidélité E.Leclerc et l’avoir rattachée dans votre compte client sur les sites E.leclerc, Drive E.Leclerc ou dans les applications mobiles Mon E.leclerc ou LeclercDrive.</p>',
          '</div>',
          '<div style="display: flex; align-items: center; gap: 24px; padding: 32px 0; border-bottom: 1px solid rgba(116, 116, 116, 0.2);">',
          '<span style="flex-shrink: 0; color: #003494; font-size: 50px; line-height: normal; font-family: var(--font-family-bold);">2</span>',
          '<p style="color: #003494; font-size: 16px; line-height: normal; font-family: var(--font-family-light); margin: 0;">Avoir renseigné votre magasin préféré dans votre compte Carte E.Leclerc (magasin de France Métropolitaine ou de Corse) dans votre compte client sur le sites E.Leclerc, Drive E.Leclerc.</p>',
          '</div>',
          '<p style="color: #747474;margin-bottom: 10px;font-family: var(--font-family-normal);font-size: 14px;">(1) Quelles sont les sociétés de l’enseigne E.Leclerc ?</p>',
          '<p style="color: #747474;margin-bottom: 10px;font-family: var(--font-family-normal);font-size: 14px;">Votre adresse email et/ou votre numéro de téléphone mobile seront transmis uniquement aux sociétés de l’enseigne E.Leclerc. Vous pourrez recevoir des emails et/ou des sms de la part de :</p>',
          '<ul style="color: #747474;font-size: 14px;margin: 0;font-family: var(--font-family-normal);"><li>Votre magasin E.Leclerc et ses magasins spécialisés (parapharmacie, optique, l’auto, station-service, drive, animalerie, brico, jardi, jouet, le manège à bijoux, une heure pour soi, espace culturel, location, sport, voyages, occasion),</li> </ul>',
          '<ul style="color: #747474;font-size: 14px;margin: 0;font-family: var(--font-family-normal);"><li>La société L-Commerce, qui édite les sites E.Leclerc, maisonetloisirs.leclerc, optique.leclerc, photo.leclerc, e-librairie.leclerc, auto.leclerc,</li> </ul>',
          '<ul style="color: #747474;font-size: 14px;margin: 0;font-family: var(--font-family-normal);"><li>Le Groupement d’Achat des Centres E.Leclerc (SC GALEC) qui réalise la communication commerciale E.Leclerc,</li> </ul>',
          '<ul style="color: #747474;font-size: 14px;margin: 0;font-family: var(--font-family-normal);"><li>Les sociétés qui gèrent la livraison à domicile ou en point relais,</li> </ul>',
          '<ul style="color: #747474;font-size: 14px;margin: 0;font-family: var(--font-family-normal);"><li>La société E.Leclerc Voyages qui édite le site <a target="_blank" href="https://www.leclercvoyages.com/">leclercvoyages.com,</a></li> </ul>',
          '<ul style="color: #747474;font-size: 14px;margin: 0;font-family: var(--font-family-normal);"><li>La société Siplec spécialisée dans les métiers de l’énergie et dans l’approvisionnement de produits manufacturés pour l’enseigne E.Leclerc et l’édition des sites primes-energie.leclerc, energies.leclerc et cartecarburant.leclerc, sous la marque E.LECLERC ENERGIES,</li> </ul>',
          '<ul style="color: #747474;font-size: 14px;margin: 0;font-family: var(--font-family-normal);"><li>La société Devinlec qui édite le site <a target="_blank"href="https://www.lemanegeabijoux.com/">lemanegeabijoux.com,</a></li> </ul>',
          '<ul style="color: #747474;font-size: 14px;margin: 0;font-family: var(--font-family-normal);"><li>La Banque Edel qui participe notamment à la gestion des cartes cadeau E.Leclerc, des cartes de crédit REGLO finance et des produits d’assurance Garantie Remboursement Intégral,</li> </ul>',
          '<ul style="color:#747474;font-size: 14px;margin: 0;font-family: var(--font-family-normal);"><li>La société L Telecom qui édite le site <a target="_blank"href="https://reglomobile.fr/">reglomobile.fr,</a></li> </ul>',
          '<ul style="color: #747474;font-size: 14px;margin: 0;font-family:var(--font-family-normal);"><li>La société Conso Régie qui est la régie publicitaire de l’enseigne E.Leclerc et met en ligne des publicités pour l’enseigne E.Leclerc.</li> </ul>',
          '<p style="color: #747474;margin: 10px 0;font-size: 14px;font-family: var(--font-family-normal);">(2) Comment sont adaptées les offres E.Leclerc en fonction de mes achats et mes envies ?</p>',
          '<p style="color: #747474;margin:0;font-family: var(--font-family-normal);font-size: 14px;>Un profilage est réalisé à partir de votre historique d’achats aux fins d’adapter les offres commerciales qui vous sont adressées. Ce profilages permet une segmentation des clients E.Leclerc, ainsi que la diffusion de manière automatisée d’offres commerciales personnalisées sur divers supports (ticket de caisse, courrier, distribution d’échantillons, bannière publicitaire sur internet et applications mobiles et, si vous avez consenti, par email et/ ou SMS, ou via votre enceinte "intelligente" si vous bénéficiez du service Assistant vocal E.Leclerc).<br/> Le profilage s’effectue par un suivi de vos achats dans chacun des circuits de distribution E.Leclerc, en considérant le contenu de votre panier d’achat. Ce suivi tient également compte de votre fidélité dans le temps.<br/>Les données utilisées pour le profilage sont celles que vous avez fournies directement et celles qui sont générées par vos habitudes d’achat au sein de l’enseigne E.Leclerc. </p>',
        ],
        templateAfterForm: [
          '<div style="padding-top: 2rem;max-width: 1130px; margin: 3rem auto; padding: 0 8vw;" id="legal-notice">',
          '<h1 style="font-size: 40px;color: #003494; font-family: var(--font-family-bold); border-top: 1px solid #f3f3f3; border-bottom: 1px solid #f3f3f3;padding: 30px 0px;text-align:center">Conditions Générales d‘Utilisation</h1>',
          '<p style="font-size: 14px; color:#747474; font-family: var(--font-family-normal);margin:0;padding-top: 2rem;">Les présentes Conditions générales d’utilisation du site ont pour objet de fixer les conditions d’accès et d’utilisation des services proposés sur le Site.</p>',
          '<p style="font-size: 14px; color:#747474; font-family: var(--font-family-normal);">L’Utilisateur désigne la personne qui se rend sur le Site www.parcours-bonus.leclerc. Les termes « vous » ou « vos » font référence à vous en tant qu’Utilisateur du Site.</p>',
          '<p style="font-size: 14px; color:#747474; font-family: var(--font-family-bold);" >ARTICLE 1. <br/>SERVICE PROPOSÉ</p>',
          '<p style="font-size: 12px; color:#747474; font-family: var(--font-family-normal);" >Le service est proposé à tout client titulaire d’une carte de fidélité E.Leclerc rattachée à un magasin préféré physique situé en France Métropolitaine ou en Corse tel qu’indiqué dans son compte Carte E.Leclerc. Le renseignement du magasin préféré peut également s’effectuer depuis le compte E.Leclerc sur les sites <a href="https://www.e.leclerc/" target="_blank" aria-label="Accéder au site www.e.leclerc" title="Accéder au site www.e.leclerc">,www.e.leclerc,</a> <a href="https://www.leclercdrive.fr/" target="_blank" aria-label="Accéder au site www.leclercdrive.fr" title="Accéder au site www.leclercdrive.fr">www.leclercdrive.fr</a> ou depuis les applications mobiles E.Leclerc suivantes : Mon E.Leclerc, LeclercDrive.</p>',
          '<p style="font-size: 12px; color:#747474; font-family: var(--font-family-normal);">Il donne un accès privilégié à des parcours parmi lesquels chaque client participant pourra les sélectionner.</p>',
          '<p style="font-size: 12px; color:#747474; font-family: var(--font-family-normal);margin-bottom:0;">Le jeu se déroule du 1er juillet 2024 au 31 décembre 2026, en plusieurs opérations de 8 semaines. Les dates exactes de chaque opération figurent dans les mails qui seront envoyés aux clients et sur la page du Site www.parcours-bonus.leclerc.</p>',
          '<p style="font-size: 12px; color:#747474; font-family: var(--font-family-normal);margin-bottom:0;">En achetant ses produits éligibles sur <a href="https://www.leclercdrive.fr/" target="_blank" aria-label="Accéder au site www.leclercdrive.fr" title="Accéder au site www.leclercdrive.fr">www.leclercdrive.fr,</a> ou en magasin, le client fait progresser ses parcours.</p>',
          '<p style="font-size: 12px; color:#747474; font-family: var(--font-family-normal);margin-bottom:0;">Au fur et à mesure de sa progression, il accède à des paliers qui lui permettent de cumuler des Tickets E.Leclerc qui lui seront reversés après la fin d’une opération.</p>',
          '<p style="font-size: 12px; color:#747474; font-family: var(--font-family-normal);">Les parcours sont cumulables avec toutes les offres en cours.<br/>Pour suivre l’avancement de ses parcours, le client doit se rendre sur sur la page du Site<br/>www.parcours-gagnants.bonus, accessible depuis l’email envoyé directement dans sa boite email, depuis son compte E.Leclerc sur les sites <a href="https://www.e.leclerc/" target="_blank" aria-label="Accéder au site www.e.leclerc" title="Accéder au site www.e.leclerc">www.e.leclerc,</a> <a href="https://www.leclercdrive.fr/" target="_blank" aria-label="Accéder au site www.leclercdrive.fr" title="Accéder au site www.leclercdrive.fr">www.leclercdrive.fr</a> depuis les applications mobiles E.Leclerc : Mon E.Leclerc, LeclercDrive.<br/>Cette page Parcours Bonus + est mise à jour au plus tard 3 jours après ses achats. La date de la dernière mise à jour y est indiquée. </p>',
          '<p style="font-size: 12px; color:#747474; font-family: var(--font-family-normal);">La sélection des parcours est faite par le titulaire sur la page du Site www.parcours-bonus.leclerc. Cependant, si plusieurs personnes utilisent la même carte de fidélité, tous les achats comptabilisés sur cette carte seront pris en compte, sous réserve qu’ils correspondent bien aux parcours sélectionnés.</p>',
          '<p style="font-size: 14px; color:#747474; font-family: var(--font-family-bold);" >ARTICLE 2. <br/>ACCEPTATION DES CONDITIONS GÉNÉRALES D’UTILISATION DU SITE</p>',
          '<p style="font-size: 12px; color:#747474; font-family: var(--font-family-normal);">Les présentes conditions sont destinées aux Utilisateurs du Site. L’Utilisateur est présumé connaître et accepter, sans réserve, l’ensemble des conditions d’utilisation du Site du seul fait de sa connexion au Site et de son utilisation des Services, quels que soient les terminaux numériques de réception utilisés. L’Utilisateur est invité à ne pas se connecter sur le Site, ni utiliser les Services s’il n’accepte pas tout ou partie des présentes.</p>',
          '<p style="font-size: 12px; color:#747474; font-family: var(--font-family-normal);">L’Editeur se réserve le droit de modifier les conditions générales d’utilisation du Site à tout moment, afin notamment de se conformer à toutes évolutions  réglementaires, jurisprudentielles, éditoriales ou techniques. L’Utilisateur est expressément  informé que la version en vigueur est celle qui est mise en ligne sur le Site, à la date de son accès à l’un quelconque des Services, ce que l’Utilisateur reconnaît et accepte sans restriction, s’engageant à s’y référer systématiquement lors de chaque connexion.</p>',
          '<p style="font-size: 14px; color:#747474; font-family: var(--font-family-bold);" >ARTICLE 3. <br/>ACCÈS AUX SERVICES ET SUSPENSION DES SERVICES</p>',
          '<p style="font-size: 14px; color:#747474; font-family: var(--font-family-normal);" >3.1 Disponibilité du Site:</p>',
          '<p style="font-size: 12px; color:#747474; font-family: var(--font-family-normal);margin-bottom:0;">L’Editeur s’engage à faire ses meilleurs efforts pour assurer que l’accès et le fonctionnement du Site soient assurés 24 heures sur 24 et 7 jours sur 7 sans interruption.</p>',
          '<p style="font-size: 12px; color:#747474; font-family: var(--font-family-normal);margin-bottom:0;">Toutefois, l’Editeur ne peut voir sa responsabilité recherchée en cas d’indisponibilité temporaire du Site :</p>',
          '<ul>',
          '<li style="font-size: 12px; color:#747474; font-family: var(--font-family-normal);margin-bottom:0;">(i) en cas de maintenance du Site ou des serveurs sur lequel elle est hébergée. </li>',
          '<li style="font-size: 12px; color:#747474; font-family: var(--font-family-normal);margin-bottom:0;">(ii) en cas de survenance d’événements extérieurs à sa volonté et à son contrôle.</li>',
          '<li style="font-size: 12px; color:#747474; font-family: var(--font-family-normal);margin-bottom:0;">(iii) en raison de cas de force majeure. </li>',
          '</ul>',
          '<p style="font-size: 12px; color:#747474; font-family: var(--font-family-normal);">L’Editeur informera au préalable l’Utilisateur de l’indisponibilité si l’événement à l’origine de  l’indisponibilité est prévisible.</p>',
          '<p style="font-size: 14px; color:#747474; font-family: var(--font-family-normal);">3.2 Suspension de l’accès:</p>',
          '<p style="font-size: 12px; color:#747474; font-family: var(--font-family-normal); margin-bottom:0;">L’Editeur se réserve le droit de  suspendre l’accès aux Services :</p>',
          '<ul>',
          '<li style="font-size: 12px; color:#747474; font-family: var(--font-family-normal);margin-bottom:0;">(i) en cas d’utilisation non conforme aux dispositions des  présentes.</li>',
          '<li style="font-size: 12px; color:#747474; font-family: var(--font-family-normal);margin-bottom:0;">(ii) en cas d’opérations de maintenance.</li>',
          '</ul>',
          '<p style="font-size: 12px; color:#747474; font-family: var(--font-family-normal);">La responsabilité de l’Editeur ne peut être  engagée en raison de ces interruptions et des conséquences qui peuvent en découler pour l’Utilisateur. </p>',
          '<p style="font-size: 14px; color:#747474; font-family: var(--font-family-bold);" >ARTICLE 4. <br/>PROPRIÉTÉ INTELLECTUELLE</p>',
          '<p style="font-size: 12px; color:#747474; font-family: var(--font-family-normal);">Le contenu du Site et l’utilisation des Services sont protégés par la loi et notamment les dispositions du Code de propriété intellectuelle et sont exclusivement destinés à l’information et l’usage personnel de l’Utilisateur qui bénéficie d’un droit d’usage privé, non collectif et non exclusif. </p>',
          '<p style="font-size: 12px; color:#747474; font-family: var(--font-family-normal);margin-bottom:0;">Sauf autorisation expresse et  préalable de l’Editeur, sont interdites toutes reproduction, représentation et utilisation autres  que celles visées ci-dessus et notamment: </p>',
          '<ul>',
          '<li style="font-size: 12px; color:#747474; font-family: var(--font-family-normal);margin-bottom:0;">(i) toute adaptation, mise à disposition du public à sa  demande ou non, distribution, rediffusion sous quelque forme que ce soit, mise en réseau, communication publique de tout ou partie des oeuvres, prestations, marques et tout éléments protégés ou susceptibles de protection par le droit de la propriété intellectuelle reproduits sur le Site</li>',
          '<li style="font-size: 12px; color:#747474; font-family: var(--font-family-normal);margin-bottom:0;">(ii) toute extraction ou réutilisation, y compris à des fins privées, d’une partie substantielle  du contenu des bases de données constituées par le Site.</li>',
          '<li style="font-size: 12px; color:#747474; font-family: var(--font-family-normal);margin-bottom:0;">(iii) toute extraction ou réutilisation,  répétée et systématique, y compris à des fins privées, d’une partie même non substantielle du contenu des bases de données constituées par le Site.</li>',
          '<li style="font-size: 12px; color:#747474; font-family: var(--font-family-normal);">(iv) tout lien, accès, modification, ajout, suppression qui porte sur le système de traitement automatisé de l’édition en ligne et modifie les conditions de publication ou la politique éditoriale. La marque et tout autre élément  protégeable au titre de la propriété intellectuelle appartenant à l’Editeur, constituent des signes distinctifs.</li>',
          '</ul>',
          '<p style="font-size: 12px; color:#747474; font-family: var(--font-family-normal);">Sauf autorisation expresse et préalable, tout usage de ces signes distinctifs ainsi que tous autres signes distinctifs appartenant à l’Editeur ou à des tiers, expose l’Utilisateur à des poursuites pénales et/ou civiles. </p>',
          '<p style="font-size: 14px; color:#747474; font-family: var(--font-family-bold);" >ARTICLE 5. <br/>PROTECTION DES DONNÉES À CARACTÈRE PERSONNEL</p>',
          '<p style="font-size: 12px; color:#747474; font-family: var(--font-family-normal);">Nous vous invitons à vous référer à la Charte de Protection des données à caractère personnel accessible <a href="https://e-leclerc.scene7.com/is/content/gtinternet/SUE/Carte%20de%20fid%C3%A9lit%C3%A9/Charte%20de%20protection%20des%20donn%C3%A9es%20personnelles_carte%20de%20fid%C3%A9lit%C3%A9%2017041024.pdf?utm_source=dialoginsight&utm_medium=email&utm_campaign=M68768"target="_blank">ici.</a></p>',
          '<p style="font-size: 14px; color:#747474; font-family: var(--font-family-bold);" >ARTICLE 6. <br/>LOI APPLICABLE ET JUGE COMPÉTENT</p>',
          '<p style="font-size: 12px; color:#747474; font-family: var(--font-family-normal);">Le non-respect par l’Utilisateur, quelle que soit sa localisation, de l’une quelconque des dispositions des présentes et de façon plus générale toute difficulté touchant à son exécution, son interprétation ou sa validité, sont soumis à la loi Française et aux juridictions françaises.</p>',
          '</div>',
        ],
        templateBeforeChanges: [
          '<div style=" max-width: 1130px;  margin: 3rem auto;padding: 0 8vw;">',
          '<p style="color: #747474;margin: 0;font-family: var(--font-family-normal);font-size: 14px; line-height: 24px;">*Les Tickets E.Leclerc sont des bons d’achat réservés aux porteurs de la Carte E.Leclerc, sur présentation en caisse de la Carte E.Leclerc et valables dès le lendemain de leur obtention, cumulables sur la Carte E.Leclerc et utilisables sur tous les produits de l’ensemble des centres E.Leclerc participant au programme de fidélité hors carburants. Les offres bénéficiant d’un Ticket E.Leclerc sont limitées à 15 produits par foyer par opération. Carte E.Leclerc 100% gratuite et disponible immédiatement. Offre en Ticket E.Leclerc non cumulable avec des produits de la même gamme bénéficiant d’un autre “Ticket E.Leclerc” ou d’une autre promotion.</p>',
          '<p style="color: #747474;margin: 0;font-family: var(--font-family-normal);font-size: 14px; line-height: 24px;">Les informations recueillies lors de l’adhésion au programme Carte de fidélité E.Leclerc sont utilisées pour le traitement et la gestion de ce programme. Elles sont conservées pendant vingt-quatre mois à compter de la dernière prise de contact émanant de l’utilisateur ou utilisation de la Carte de fidélité E.Leclerc.</p>',
          '<p style="color: #747474;margin: 0;font-family: var(--font-family-normal);font-size: 14px; line-height: 24px;">Le montant de Tickets E.Leclerc que vous pouvez cumuler dans le cadre des Parcours Gagnants dépend des parcours personnalisés qui vous sont proposés. Ce montant peut atteindre au maximum 50 €.</p>',
          '<p style="color: #747474;margin: 0;font-family: var(--font-family-normal);font-size: 14px; line-height: 24px;">Les Tickets E.Leclerc cumulés dans le cadre des Parcours Gagnants seront crédités sur votre Carte E.Leclerc dans un délai de 15 jours à partir de la date de fin de chaque opération.</p>',
          '</div>',
        ],
      },
      displayContactUsUnlogged: true,
      displayFooterUnlogged: false,
    },
    currentChallenges: {
      meta: {
        title: 'Mes Parcours Gagnants | E.Leclerc',
        keywords:
          'Tickets, E.Leclerc, Parcours, Cumulez, Participez, Gagnez, Carte, Fidélité',
        description:
          "Participez à vos parcours pour tenter de gagner jusqu'a 50€ avec la carte E.Leclerc",
      },
      creditDateNumber: 15,
      howToPlay: {
        specificDisplayCondition: DISPLAY_CONDITION.NEVER,
      },
      background: '#003494',
      campaignEndMsg: {
        color: 'white',
        backgroundColor: 'rgb(75, 75, 75)',
        fontFamily: 'var(--font-family-roboto-medium)',
        text: '<span>INFORMATION:</span> Les Tickets E.Leclerc cumulés dans le cadre de vos Parcours Gagnants du startDate au endDate vous seront crédités au plus tard le creditDate',
      },
      templateBeforeChanges: [
        '<div style="padding: 0 8vw 5vw;">',
        '<p style="color: white;font-family: var(--font-family-normal);margin: 0;font-size: 14px; line-height: 20px;">*Les Tickets E.Leclerc sont des bons d’achat réservés aux porteurs de la Carte E.Leclerc, sur présentation en caisse de la Carte E.Leclerc et valables dès le lendemain de leur obtention, cumulables sur la Carte E.Leclerc et utilisables sur tous les produits de l’ensemble des centres E.Leclerc participant au programme de fidélité hors carburants. Les offres bénéficiant d’un Ticket E.Leclerc sont limitées à 15 produits par foyer par opération. Carte E.Leclerc 100% gratuite et disponible immédiatement. Offre en Ticket E.Leclerc non cumulable avec des produits de la même gamme bénéficiant d’un autre “Ticket E.Leclerc” ou d’une autre promotion.</p>',
        '<p style="color: white;font-family: var(--font-family-normal);margin: 0;font-size: 14px; line-height: 20px;">Les informations recueillies lors de l’adhésion au programme Carte de fidélité E.Leclerc sont utilisées pour le traitement et la gestion de ce programme. Elles sont conservées pendant vingt-quatre mois à compter de la dernière prise de contact émanant de l’utilisateur ou utilisation de la Carte de fidélité E.Leclerc.</p>',
        '<p style="color: white;font-family: var(--font-family-normal);margin: 0;font-size: 14px; line-height: 2àpx;">Le montant de Tickets E.Leclerc que vous pouvez cumuler dans le cadre des Parcours Gagnants dépend des parcours personnalisés qui vous sont proposés. Ce montant peut atteindre au maximum 50 €.</p>',
        '<p style="color: white;font-family: var(--font-family-normal);margin: 0;font-size: 14px; line-height: 2àpx;">Les Tickets E.Leclerc cumulés dans le cadre des Parcours Gagnants seront crédités sur votre Carte E.Leclerc dans un délai de 15 jours à partir de la date de fin de chaque opération.</p>',
        '</div>',
      ],
    },
    currentChallengesBis: {
      meta: {
        title: 'Mes Parcours Bonus+ | E.Leclerc',
        keywords:
          'Tickets, E.Leclerc, Parcours, Bonus+, Cumulez, Participez, Gagnez, Carte, Fidélité',
        description:
          "Participez à vos parcours pour tenter de gagner jusqu'a 50€ avec la carte E.Leclerc",
      },
      variant: Variants.VARIANT_2,
      ariaLabel:
        'Accéder à la page Mes Parcours Bonus pour cumuler encore plus de Tickets E.Leclerc',
      backgroundColor: 'white',
      templateCurrentBisPageBanner: {
        mobile: [
          '<p style="max-width: 312px; margin: 0 auto; padding: 14px 16px; color: #003494; font-size: 14px; line-height: 1.2; text-align: center; text-transform: uppercase; font-family: var(--font-family-bold);"><span aria-hidden="true">←</span> N’oubliez pas de sélectionner vos Parcours Gagnants !</p>',
        ],
        tablet: [
          '<p style="margin: 0; padding: 11px 16px; color: #003494; font-size: 16px; line-height: 1.2; text-align: center; text-transform: uppercase; font-family: var(--font-family-bold);"><span aria-hidden="true">←</span> N’oubliez pas de sélectionner vos Parcours Gagnants !</p>',
        ],
        desktop: [
          '<p style="margin: 0; padding: 11px 16px; color: #003494; font-size: 16px; line-height: 1.2; text-align: center; text-transform: uppercase; font-family: var(--font-family-bold);"><span aria-hidden="true">←</span> N’oubliez pas de sélectionner vos Parcours Gagnants !</p>',
        ],
      },
      header: {
        variant: Variants.VARIANT_7,
        backgroundColor: 'white',
        dateTemplate: 'Du {variable} au {variable}',
        datesBackgroundColor: '#FFDE33',
        logo: {
          imageUrl: 'assets/images/chondrus/logo-mes-parcours-bonus.webp',
          alternativeText: 'Mes Parcours Bonus+',
        },
        headline: 'Cumulez encore +\nsur vos produits\ndu quotidien*',
        headlineColor: '#003494',
        footnote: '*Produits non-alimentaires',
      },
      challengeSummary: {
        variant: Variants.VARIANT_4,
        title: {
          text: 'Vos parcours',
          color: '#003494',
          fontFamily: 'var(--font-family-bold)',
        },
        update: {
          color: '#003494',
          text: 'Mise à jour le {variable}',
          fontFamily: 'var(--font-family-roboto-medium)',
          dateFormat: 'dd/MM/yy',
        },
        label: {
          color: 'white',
          mobileText: 'Défis sélectionnés',
          desktopText: 'Défis sélectionnés',
          backgroundColor: '#003494',
          fontFamily: 'var(--font-family-bold)',
        },
        completedLabel: 'Défis terminés',
        separatorIconUrl: 'assets/images/chondrus/star-white.svg',
        tooltip: {
          visible: true,
          icon: 'assets/images/chondrus/info-navy.svg',
          content:
            "Mise à jour des Parcours <br/>Vos transactions peuvent mettre jusqu'à 72 heures à apparaître. <br/> Si vous avez des questions, consultez les FAQ dans la rubrique «Aide» et si vous ne trouvez pas la réponse à votre question, renseignez-la dans le formulaire.",
          position: 'right',
          alternativeText: 'Cliquez pour afficher le message',
        },
      },
      templateCurrentPageBanner: {
        mobile: [
          '<p style="max-width: 312px; margin: 0 auto; padding: 14px 16px; color: #003494; font-size: 14px; line-height: 1.2; text-align: center; text-transform: uppercase; font-family: var(--font-family-bold);">Cumulez encore + de Tickets E.Leclerc avec Mes Parcours Bonus <span aria-hidden="true">→</span></p>',
        ],
        tablet: [
          '<p style="margin: 0; padding: 11px 16px; color: #003494; font-size: 16px; line-height: 1.2; text-align: center; text-transform: uppercase; font-family: var(--font-family-bold);">Cumulez encore + de Tickets E.Leclerc avec Mes Parcours Bonus <span aria-hidden="true">→</span></p>',
        ],
        desktop: [
          '<p style="margin: 0; padding: 11px 16px; color: #003494; font-size: 16px; line-height: 1.2; text-align: center; text-transform: uppercase; font-family: var(--font-family-bold);">Cumulez encore + de Tickets E.Leclerc avec Mes Parcours Bonus <span aria-hidden="true">→</span></p>',
        ],
      },
      templateAuthPageBanner: {
        mobile: [
          '<div style=" flex-direction: row;height: 80px;justify-content: center;display: flex";> ',
          '<p style="font-family: var(--font-family-normal); letter-spacing: .7px; line-height: 30px;margin-bottom: 0;text-align: center;padding: 10px; font-size: 15px; color: white";>Cumulez <span style="font-family: var(--font-family-medium)";>Encore+ de Tickets E.Leclerc</span> <br/> <span style="font-family: var(--font-family-normal)";>Avec</span> <span style="background-color:#003494; font-family: var(--font-family-bold); padding:8px 5px;text-transform: uppercase;";> Mes Parcours Bonus <img style="width: 20px; height: 20px;" alt="Cumulez plus de tickets E.Leclerc avec mes parcours bonus+" src="assets/images/chondrus/bonus-plus-white.svg"/></span></p>',
          '</div>',
        ],
        tablet: [
          '<div style="height: 80px;display: flex;justify-content: center;align-items: center;line-height:4.5vw;";> ',
          '<p style="font-family: var(--font-family-normal); letter-spacing: .7px; margin-bottom: 0;margin-left: 2vw;text-align: center;padding: 10px; font-size: 3vw; color: white";>Cumulez <span style="font-family: var(--font-family-medium)";>Encore + de Tickets E.Leclerc</span> <br/> <span style="font-family: var(--font-family-normal)";>Avec</span><span style="background-color:#003494; font-family: var(--font-family-bold);margin-left: 2vw; padding:8px 5px;text-transform: uppercase;";> Mes Parcours Bonus <img style="width: 20px; height: 20px;" alt="Cumulez plus de tickets E.Leclerc avec mes parcours bonus+" src="assets/images/chondrus/bonus-plus-white.svg"/></span></p>',
          '</div>',
        ],
        desktop: [
          '<div style="height: 90px;justify-content: center;align-items: center;display: flex";> ',
          '<p style="font-family: var(--font-family-normal); margin-left: 25px;letter-spacing: 2px; margin-bottom: 0;text-align: center; font-size: 2.5vw; color: white";>Cumulez <span style="font-family: var(--font-family-medium)";>Encore + de Tickets E.Leclerc</span> <span style="font-family: var(--font-family-normal)";>Avec</span> <span style="background-color:#003494; font-family: var(--font-family-bold);margin-left: 2vw; font-size: 2vw;padding: 1vw 1vw 0.8vw 1vw;text-transform: uppercase;";> Mes Parcours Bonus <img style="width: 30px;position: relative;top: -3px;" alt="Cumulez plus de tickets E.Leclerc avec mes parcours bonus+" src="assets/images/chondrus/bonus-plus-white.svg"/></span></p>',
          '</div>',
        ],
      },
      campaignEndMsg: {
        color: 'white',
        creditDateNumber: 15,
        backgroundColor: 'rgb(75, 75, 75)',
        fontFamily: 'var(--font-family-roboto-medium)',
        text: '<span>INFORMATION:</span> Les Tickets E.Leclerc cumulés dans le cadre de vos Parcours Bonus+ du startDate au endDate vous seront crédités au plus tard le creditDate',
      },
    },
    pastChallenges: {
      meta: {
        title: 'Historique De Vos Parcours | E.Leclerc',
        keywords:
          'Tickets, E.Leclerc, Parcours, Cumulez, Participez, Gagnez, Carte, Fidélité, historique De Vos Parcours, mes parcours gagnats, mes parcours bonus+',
        description:
          "Participez à vos parcours pour tenter de gagner jusqu'a 50€ avec la carte E.Leclerc",
      },
      banner: {
        visibility: true,
        title: 'Tout L’historique De Vos Parcours Ici',
        bannerAriaLabel: 'Page d’historique affichant les défis passés',
        background: 'white',
        styles: {
          title: {
            margin: 'unset',
            color: '#003494',
            fontSize: '30px',
            lineHeight: '1.2',
            textAlign: 'center',
            textTransform: 'uppercase',
            fontFamily: 'var(--font-family-bold)',
          },
          banner: {
            marginTop: '0',
            height: '140px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          },
        },
      },
      accordion: {
        variant: Variants.VARIANT_2,
        iconMore: 'assets/images/chondrus/expand-more.svg',
        iconLess: 'assets/images/chondrus/expand-less.svg',
        alternativeTextExpandMore: 'Développer la section',
        alternativeTextExpandLess: 'Réduire la section',
        date: {
          color: '#003494',
          format: 'dd/MM/yyyy',
          template: 'Du {startDate} au {endDate}',
          fontFamily: 'var(--font-family-medium)',
        },
        reward: {
          color: 'white',
          backgroundColor: '#003494',
          fontFamily: 'var(--font-family-bold)',
        },
      },
      noChallengesText: {
        color: '#003494',
        fontFamily: 'var(--font-family-light)',
        text: 'Pas de challenge sélectionné',
      },
      noRewardsText: {
        color: '#0066CC',
        fontFamily: 'var(--font-family-light)',
        text: 'Pas de récompense gagnée',
      },
      templateBeforeChanges: [
        '<div style="padding: 5vw 0;">',
        '<p style="color: #747474;margin: 0;font-family: var(--font-family-normal);font-size: 14px; line-height: 24px;">*Les Tickets E.Leclerc sont des bons d’achat réservés aux porteurs de la Carte E.Leclerc, sur présentation en caisse de la Carte E.Leclerc et valables dès le lendemain de leur obtention, cumulables sur la Carte E.Leclerc et utilisables sur tous les produits de l’ensemble des centres E.Leclerc participant au programme de fidélité hors carburants. Les offres bénéficiant d’un Ticket E.Leclerc sont limitées à 15 produits par foyer par opération. Carte E.Leclerc 100% gratuite et disponible immédiatement. Offre en Ticket E.Leclerc non cumulable avec des produits de la même gamme bénéficiant d’un autre “Ticket E.Leclerc” ou d’une autre promotion.</p>',
        '<p style="color: #747474;margin: 0;font-family: var(--font-family-normal);font-size: 14px; line-height: 24px;">Les informations recueillies lors de l’adhésion au programme Carte de fidélité E.Leclerc sont utilisées pour le traitement et la gestion de ce programme. Elles sont conservées pendant vingt-quatre mois à compter de la dernière prise de contact émanant de l’utilisateur ou utilisation de la Carte de fidélité E.Leclerc.</p>',
        '<p style="color: #747474;margin: 0;font-family: var(--font-family-normal);font-size: 14px; line-height: 24px;">Le montant de Tickets E.Leclerc que vous pouvez cumuler dans le cadre des Parcours Gagnants dépend des parcours personnalisés qui vous sont proposés. Ce montant peut atteindre au maximum 50 €.</p>',
        '<p style="color: #747474;margin: 0;font-family: var(--font-family-normal);font-size: 14px; line-height: 24px;">Les Tickets E.Leclerc cumulés dans le cadre des Parcours Gagnants seront crédités sur votre Carte E.Leclerc dans un délai de 15 jours à partir de la date de fin de chaque opération.</p>',
        '</div>',
      ],
    },
    futureChallenges: {
      meta: {
        title: 'Vos Prochains Parcours | E.Leclerc',
        keywords:
          'Tickets, E.Leclerc, Parcours, Cumulez, Participez, Gagnez, Carte, Fidélité, Vos Prochains Parcours',
        description:
          "Participez à vos parcours pour tenter de gagner jusqu'a 50€ avec la carte E.Leclerc",
      },
      banner: {
        visibility: true,
        background: 'white',
        title: 'Vos Prochains Parcours Ici',
        label:
          'Sélectionnez dès à présent vos parcours du {firstDate} au {lastDate} !',
        complimentaryMsg:
          'Faites vos courses avec votre Carte E.Leclerc pour cagnotter des Tickets E.Leclerc',
        campaignInfo: {
          template: '',
          dateFormat: 'dd/MM/yyyy ',
        },
        styles: {
          title: {
            color: '#003494',
            fontSize: '30px',
            lineHeight: '1.2',
            marginTop: '1rem',
            marginBottom: '1.5rem',
            textAlign: 'center',
            textTransform: 'uppercase',
            fontFamily: 'var(--font-family-bold)',
          },
          label: {
            color: '#003494',
            fontSize: '18px',
            lineHeight: '24px',
            maxWidth: '504px',
            padding: '0 16px',
            marginTop: '0',
            textAlign: 'center',
            fontFamily: 'var(--font-family-roboto-medium)',
          },
          complimentaryMsg: {
            color: '#003494',
            fontSize: '18px',
            lineHeight: '24px',
            maxWidth: '504px',
            padding: '0 16px',
            marginTop: '24px',
            textAlign: 'center',
            fontFamily: 'var(--font-family-roboto-medium)',
          },
          banner: {
            display: 'flex',
            marginTop: '2rem',
            alignItems: 'center',
            flexDirection: 'column',
            justifyContent: 'center',
          },
          date: {
            display: 'flex',
            color: '#003494',
            fontFamily: 'var(--font-family-light)',
            fontSize: '15px',
            alignItems: 'center',
            flexDirection: 'column',
          },
        },
      },
    },
    sorry: {
      background:
        '#F2F2F2 url("assets/images/chondrus/sorry-page-image.webp") center center / contain no-repeat',
      content: [
        '<img src="assets/images/chondrus/retailer-logo-blue.webp" alt="Mes parcours Gagnants logo">',
        '<div style="font-size: 1.5rem; text-align: center; color: #003494; font-family: var(--font-family-bold);">Parcours Gagnants n’est pas disponible pour le moment</div>',
      ],
    },
    authPage: {
      variant: Variants.VARIANT_2,
      meta: {
        title: 'Parcours Gagnants | E.Leclerc | Authentification',
        keywords:
          'Tickets, E.Leclerc, Parcours, Bonus+, Cumulez, Participez, Gagnez, Carte, Fidélité',
        description:
          'Le montant de Tickets E.Leclerc que vous pouvez cumuler dans le cadre des Parcours Gagnants dépend des parcours personnalisés qui vous sont proposés. Ce montant peut atteindre au maximum 50 €',
      },
      header: {
        logos: {
          mobile: [
            {
              imageUrl: 'assets/images/chondrus/logo-leclerc-icon.webp',
              alternativeText: 'E.Leclerc',
            },
            {
              imageUrl: 'assets/images/chondrus/logo-mes-parcours.webp',
              alternativeText: 'Mes Parcours',
            },
          ],
          tablet: [
            {
              imageUrl: 'assets/images/chondrus/logo-leclerc-icon.webp',
              alternativeText: 'E.Leclerc',
            },
            {
              imageUrl: 'assets/images/chondrus/logo-mes-parcours.webp',
              alternativeText: 'Mes Parcours',
            },
          ],
          desktop: [
            {
              imageUrl: 'assets/images/chondrus/logo-leclerc.webp',
              alternativeText: 'E.Leclerc',
            },
            {
              imageUrl: 'assets/images/chondrus/logo-mes-parcours.webp',
              alternativeText: 'Mes Parcours',
            },
          ],
        },
      },
      programmes: [
        {
          theme: 'navy',
          logo: {
            imageUrl: 'assets/images/chondrus/logo-mes-parcours-gagnants.webp',
            alternativeText: 'Mes Parcours Gagnants',
          },
          sticker: {
            imageUrl: 'assets/images/chondrus/header-max-reward.svg',
            alternativeText: 'Ticket E.Leclerc jusqu’à 50€ avec la Carte',
          },
          text: 'Cumulez sur vos marques<br/>alimentaires préférées',
        },
        {
          theme: 'white',
          requiresBisCampaign: true,
          logo: {
            imageUrl: 'assets/images/chondrus/logo-mes-parcours-bonus.webp',
            alternativeText: 'Mes Parcours Bonus+',
          },
          sticker: {
            imageUrl: 'assets/images/chondrus/ticket-argent.webp',
            alternativeText:
              'Ticket E.Leclerc, le ticket qui vaut de l’argent avec la Carte',
          },
          text: 'Cumulez encore + sur vos<br/>produits du quotidien*',
          footnote: '*Produits non-alimentaires',
        },
      ],
      loginBlock: {
        title:
          '<span class="title-top">À vous </span>de <span class="highlight">jouer</span>!',
        intro: {
          picture: {
            imageUrl: 'assets/images/chondrus/step0.webp',
            alternativeText:
              'Carte E.Leclerc - Qualité, Innovation, Fidélité, Responsabilité',
          },
          text: 'Indiquez votre numéro de carte ainsi que votre code secret',
        },
        fields: [
          {
            type: 'number',
            formControlName: 'card',
            placeholder: 'Exemple : 7896548765678',
            required: true,
            label: 'Votre numéro de carte (13 chiffres)*',
            validations: [
              {
                type: 'required',
                message: 'Veuillez entrer un numéro valide',
              },
              {
                type: 'pattern',
                pattern: '.{12}[0-9]',
                message: 'Veuillez entrer un numéro valide',
              },
            ],
          },
          {
            type: 'number',
            formControlName: 'code',
            placeholder: 'Exemple : 9578',
            required: true,
            label: 'Votre code secret (4 chiffres)*',
            validations: [
              {
                type: 'required',
                message: 'Veuillez entrer un code valide',
              },
              {
                type: 'pattern',
                pattern: '[0-9]{4}',
                message: 'Veuillez entrer un code valide',
              },
            ],
          },
        ],
        secretToggle: {
          formControlName: 'code',
          iconUrl: 'assets/images/chondrus/eye-off-navy.svg',
          showLabel: 'Afficher le code secret',
          hideLabel: 'Masquer le code secret',
        },
        linkToCard: {
          ariaLabel: 'S’inscrire pour obtenir la carte E.Leclerc',
          label: 'Obtenez votre carte leclerc',
          url: 'https://www.e.leclerc/e/carte-eleclerc',
        },
        acceptModality: {
          ariaLabel:
            'Accéder à la page d’aide pour consulter les conditions de participation',
          url: 'help',
          label: 'Conditions de participation',
        },
        submitButton: {
          label: 'Je me connecte',
          iconUrl: 'assets/images/chondrus/arrow-right-white.svg',
        },
        errorMessage: 'Vérifiez vos informations avant de continuer',
        additionalInfoTemplate: [
          '<p class="additional-msg" style="color: white;font-size: 14px; font-family: var(--font-family-roboto-light); line-height: 23px;padding-top: 1rem;margin: unset;">',
          'Ce site est protégé par reCAPTCHA, et la <a style="font-family:var(--font-family-roboto-bold);color: white;" href="https://policies.google.com/privacy" title="Politique de confidentialité" target="_blank">Politique de confidentialité</a> ainsi que les <a style="font-family:var(--font-family-roboto-bold);color: white;" href="https://policies.google.com/terms" title="Conditions d’utilisation" target="_blank" >Conditions d’utilisation</a> de Google s’appliquent.',
          '</p>',
        ],
      },
      howToPlay: {
        specificDisplayCondition: DISPLAY_CONDITION.ALWAYS,
      },
      templateBeforeChanges: [
        '<div style="padding: 2vw 8vw 5vw;">',
        '<p style="color: #747474;margin: 0;font-family: var(--font-family-normal);font-size: 14px; line-height: 20px;">*Les Tickets E.Leclerc sont des bons d’achat réservés aux porteurs de la Carte E.Leclerc, sur présentation en caisse de la Carte E.Leclerc et valables dès le lendemain de leur obtention, cumulables sur la Carte E.Leclerc et utilisables sur tous les produits de l’ensemble des centres E.Leclerc participant au programme de fidélité hors carburants. Les offres bénéficiant d’un Ticket E.Leclerc sont limitées à 15 produits par foyer par opération. Carte E.Leclerc 100% gratuite et disponible immédiatement. Offre en Ticket E.Leclerc non cumulable avec des produits de la même gamme bénéficiant d’un autre “Ticket E.Leclerc” ou d’une autre promotion.</p>',
        '<p style="color: #747474;margin: 0;font-family: var(--font-family-normal);font-size: 14px; line-height: 20px;">Les informations recueillies lors de l’adhésion au programme Carte de fidélité E.Leclerc sont utilisées pour le traitement et la gestion de ce programme. Elles sont conservées pendant vingt-quatre mois à compter de la dernière prise de contact émanant de l’utilisateur ou utilisation de la Carte de fidélité E.Leclerc.</p>',
        '<p style="color: #747474;margin: 0;font-family: var(--font-family-normal);font-size: 14px; line-height: 20px;">Le montant de Tickets E.Leclerc que vous pouvez cumuler dans le cadre des Parcours Gagnants dépend des parcours personnalisés qui vous sont proposés. Ce montant peut atteindre au maximum 50 €.</p>',
        '<p style="color: #747474;margin: 0;font-family: var(--font-family-normal);font-size: 14px; line-height: 20px;">Les Tickets E.Leclerc cumulés dans le cadre des Parcours Gagnants seront crédités sur votre Carte E.Leclerc dans un délai de 15 jours à partir de la date de fin de chaque opération.</p>',
        '</div>',
      ],
    },
  },
  components: {
    bisCampaignTabs: [
      {
        selectedColor: '#003494',
        label:
          '<img style="display: block; height: clamp(40px, 8vw, 56px); width: auto; margin: 0 auto;" alt="Mes Parcours Gagnants" src="assets/images/chondrus/logo-mes-parcours-gagnants.webp" />',
        color: '#747474',
        selectedBorder: '4px solid #FF8615',
        fontFamily: 'var(--font-family-bold)',
        campaignType: CampaignTypes.LOYALTYCHALLENGE,
      },
      {
        selectedColor: '#003494',
        label:
          '<img style="display: block; height: clamp(40px, 8vw, 56px); width: auto; margin: 0 auto;" alt="Mes Parcours Bonus+" src="assets/images/chondrus/logo-mes-parcours-bonus.webp" />',
        color: '#747474',
        selectedBorder: '4px solid #FF8615',
        fontFamily: 'var(--font-family-bold)',
        campaignType: CampaignTypes.LOYALTYCHALLENGE_BIS,
      },
    ],
    header: {
      variant: Variants.VARIANT_7,
      backgroundColor: '#003494',
      dateTemplate: 'Du {variable} au {variable}',
      datesBackgroundColor: '#FF8615',
      logo: {
        imageUrl: 'assets/images/chondrus/logo-mes-parcours-gagnants.webp',
        alternativeText: 'Mes Parcours Gagnants',
      },
      maxReward: {
        imageUrl: 'assets/images/chondrus/header-max-reward.svg',
        alternativeText: "Ticket E.Leclerc jusqu'à 50€ avec la Carte",
      },
      headline: 'Sur vos marques\nalimentaires préférées',
      headlineColor: 'white',
    },
    brands: {
      variant: Variants.VARIANT_3,
      backgroundColor: 'var(--challenge-primary-color)',
      brandsBgColor: 'white',
      border: '1.5px solid #EFEFEF',
      label: {
        text: 'Vos Marques Préférées',
        color: 'white',
        fontFamily: 'var(--font-family-light)',
        textTransform: 'uppercase',
      },
      alternativeText: 'Logos des marques préférées',
      buttonText: 'Voir vos défis',
      ariaLabelScrollTo: 'Accéder à vos défis actuels',
    },
    footer: {
      variant: Variants.VARIANT_2,
      mobileVisiblity: true,
      styles: {
        padding: '40px clamp(16px, 6vw, 80px)',
        backgroundColor: 'white',
        borderTop: '0.5px solid #003494',
      },
      logos: [
        {
          imageUrl: 'assets/images/chondrus/logo-mes-parcours.webp',
          alternativeText: 'Mes Parcours',
        },
        {
          imageUrl: 'assets/images/chondrus/logo-leclerc.webp',
          alternativeText: 'E.Leclerc',
        },
      ],
      linkStyles: {
        color: '#003494',
        fontSize: '14px',
        lineHeight: '1.5',
        letterSpacing: '-0.02em',
        textDecoration: 'none',
        fontFamily: 'var(--font-family-roboto-medium)',
      },
      iconMore: 'assets/images/chondrus/icon-more.webp',
      iconLess: 'assets/images/chondrus/icon-less.webp',
      alternativeTextExpandMore: 'Réduire la section',
      alternativeTextExpandLess: 'Développer la section',
      links: [
        {
          url: 'help',
          fragment: 'legal-notice',
          label: 'Mentions légales',
        },
        {
          url: 'help',
          fragment: 'general-conditions',
          label: 'Conditions générales d’utilisation',
        },
        {
          external: true,
          label: 'Charte de protection des données personnelles',
          url: 'assets/files/chondrus/charte-de-protection-des-donnees-2026.pdf',
        },
        {
          external: true,
          url: 'assets/files/chondrus/declaration_accessibilite_2025.pdf',
          label: 'Télécharger la déclaration d’accessibilité',
        },
        {
          url: 'help',
          fragment: 'contact-form',
          label: 'Contact d’accessibilité',
        },
      ],
    },
    tutorial: {
      background: '#003494',
      carousel: {
        config: {
          sectionAriaLabel: 'Carrousel du tutoriel',
          controlsAriaLabel: 'Contrôles du carrousel',
          paginationAriaLabel: 'Indicateurs de diapositives',
          dots: {
            inactiveBg: 'white',
            activeBg: '#FC4F00',
            ariaLabel: 'Aller à la diapositive {variable} de {variable}',
          },
          slideIndicatorLabel: 'Diapositive {variable} sur {variable}',
          controls: {
            leftIcon: {
              imageUrl: 'assets/images/chondrus/carousel-arrow-left.svg',
              alternativeText: 'Aller à la diapositive précédente',
            },
            rightIcon: {
              imageUrl: 'assets/images/chondrus/carousel-arrow-right.svg',
              alternativeText: 'Aller à la diapositive suivante',
            },
          },
        },
        items: {
          variant: Variants.VARIANT_4,
          styles: {
            title: {
              color: 'white',
              fontFamily: 'var(--font-family-roboto-bold)',
            },
            description: {
              color: 'white',
              fontFamily: 'var(--font-family-roboto-light)',
            },
            card: {
              border: 'none',
              borderRadius: '0',
              boxShadow: 'none',
              background: 'transparent',
            },
          },
          steps: [
            {
              title:
                'Je choisis mes Parcours en fonction de mes marques préférées.',
              description:
                '10 maximum pour Mes Parcours Gagnants et possibilité de tout sélectionner pour Mes Parcours Bonus+.',
              indicatorImage: {
                imageUrl: 'assets/images/chondrus/step-number-1.svg',
                alternativeText: 'Étape 1',
              },
              picture: {
                imageUrl: 'assets/images/chondrus/tutorial-step-1.webp',
                alternativeText: 'Une carte de parcours à activer',
              },
            },
            {
              title: 'Je fais mes courses et je présente ma carte E.Leclerc',
              description:
                'Hypermarchés, Supermarchés, et E.Leclerc Drive et E.Leclerc chez moi',
              indicatorImage: {
                imageUrl: 'assets/images/chondrus/step-number-2.svg',
                alternativeText: 'Étape 2',
              },
              picture: {
                imageUrl: 'assets/images/chondrus/tutorial-step-2.svg',
                alternativeText: 'La carte de fidélité E.Leclerc',
              },
            },
            {
              title:
                'Si j’atteins mes objectifs, je cagnotte les Tickets E.Leclerc correspondants.',
              description: 'à la fin de l’opération.',
              indicatorImage: {
                imageUrl: 'assets/images/chondrus/step-number-3.svg',
                alternativeText: 'Étape 3',
              },
              picture: {
                imageUrl: 'assets/images/chondrus/ticket-argent.webp',
                alternativeText:
                  'Ticket E.Leclerc, le ticket qui vaut de l’argent avec la Carte',
              },
            },
          ],
        },
      },
    },
    wallet: {
      variant: Variants.VARIANT_4,
      label: 'Ma cagnotte',
      theme: {
        color: 'white',
        backgroundColor: '#003494',
        borderColor: '#003494',
        iconUrl: 'assets/images/chondrus/star-yellow.svg',
      },
      bisTheme: {
        color: '#003494',
        backgroundColor: 'white',
        borderColor: '#003494',
        iconUrl: 'assets/images/chondrus/star-yellow.svg',
      },
      mobileTheme: {
        color: 'white',
        backgroundColor: '#003494',
        borderColor: '#003494',
        iconUrl: 'assets/images/chondrus/star-orange.svg',
      },
      mobileBisTheme: {
        color: '#003494',
        backgroundColor: 'white',
        borderColor: '#003494',
        iconUrl: 'assets/images/chondrus/star-yellow.svg',
      },
    },
    navbar: {
      variant: Variants.VARIANT_5,
      menuVariant: Variants.VARIANT_3,
      hasLayoutPaddingTop: true,
      layoutPaddingTop: {
        [DeviceType.DESKTOP]: '158px',
        [DeviceType.TABLET]: '126px',
        [DeviceType.MOBILE]: '126px',
      },
      fontFamily: 'var(--font-family-bold)',
      dropdownLabel: 'Menu',
      retailerLogo: {
        imageUrl: 'assets/images/chondrus/logo-leclerc.webp',
        mobileImageUrl: 'assets/images/chondrus/logo-leclerc-icon.webp',
        alternativeText: 'E.Leclerc',
      },
      programTabs: [
        {
          url: 'current',
          imageUrl: 'assets/images/chondrus/logo-mes-parcours-gagnants.webp',
          alternativeText: 'Mes Parcours Gagnants',
        },
        {
          url: 'current-bis',
          imageUrl: 'assets/images/chondrus/logo-mes-parcours-bonus.webp',
          alternativeText: 'Mes Parcours Bonus',
        },
      ],
      currentPageLink: {
        label: 'Mes parcours',
        iconUrl: 'assets/images/chondrus/nav-calendar.svg',
      },
      closeButton: {
        imageUrl: 'assets/images/chondrus/close.svg',
        imageAlt: 'Fermer le menu',
        buttonTitle: 'Fermer le menu',
      },
      openButton: {
        imageUrl: 'assets/images/chondrus/menu.svg',
        buttonTitle: 'Accédez aux options du site',
        imageAlt: 'Accédez aux options du site',
      },
      logo: {
        url: 'current',
        height: '65px',
        imageUrl: 'assets/images/chondrus/logo-leclerc.webp',
        alternativeText: 'E.Leclerc',
      },
      navbarAriaLabel: 'Navigation principale',
      items: [
        {
          url: 'current',
          label: 'Mes Parcours Gagnants',
          ariaLabel:
            'Accéder à la page des Challenges en cours de Mes Parcours Gagnants',
          menuIcon: {
            imageUrl: 'assets/images/chondrus/nav-calendar.svg',
            alternativeText: '',
          },
        },
        {
          url: 'current-bis',
          cssClass: 'current-bis',
          label: 'Mes Parcours Bonus',
          ariaLabel: 'Accéder à la page des Challenges de Mes Parcours Bonus',
          menuIcon: {
            imageUrl: 'assets/images/chondrus/bonus-plus-white.svg',
            alternativeText: '',
          },
        },
        {
          url: 'soon',
          badge: true,
          badgeColor: '#FF8615',
          label: 'Prochainement',
          ariaLabel: 'Accéder à la page Prochainement',
          menuIcon: {
            imageUrl: 'assets/images/chondrus/nav-calendar.svg',
            alternativeText: '',
          },
        },
        {
          url: 'history',
          label: 'Historique',
          ariaLabel: 'Accéder à la page de l’Historique',
          menuIcon: {
            imageUrl: 'assets/images/chondrus/nav-history.svg',
            alternativeText: '',
          },
        },
        {
          url: 'help',
          label: 'Besoin d’aide',
          ariaLabel: 'Accéder à la page d’aide',
          menuIcon: {
            imageUrl: 'assets/images/chondrus/nav-help.svg',
            alternativeText: '',
          },
        },
      ],
    },
    countdown: {
      variant: Variants.VARIANT_4,
      showOnPages: 'all',
      title: 'Fin du parcours dans',
      theme: {
        color: 'white',
        boxBackgroundColor: 'rgba(255, 255, 255, 0.2)',
      },
      bisTheme: {
        color: '#003494',
        boxBackgroundColor: 'rgba(0, 52, 148, 0.15)',
      },
      mobileTheme: {
        color: '#003494',
        boxBackgroundColor: 'rgba(0, 52, 148, 0.15)',
      },
      texts: {
        days: 'j',
        hours: 'h',
        minutes: 'm',
        seconds: 's',
      },
    },
    challenges: {
      elements: {
        winCard: {
          variant: Variants.VARIANT_10,
          backgroundColor: '#005CB9',
          backgroundColorBySubType: {
            [ChondrusSubType.PARAPHARMACIE]: '#329A37',
          },
          message: {
            firstLine: 'Vous avez',
            secondLine: 'gagné',
            color: 'white',
            fontFamily: 'var(--font-family-bold)',
          },
          reward: {
            imageUrl: 'assets/images/chondrus/ticket-yellow.svg',
            alternativeText:
              'Vous avez gagné {variable}€ en Tickets E.Leclerc en terminant ce parcours',
            amountColor: '#005CB9',
            amountFontFamily: 'var(--font-family-edouard-condensed-bold)',
          },
        },
        selectionButton: {
          variant: Variants.VARIANT_2,
          accentColor: '#003494',
          accentColorBySubType: {
            [ChondrusSubType.PARAPHARMACIE]: '#329A37',
          },
          catchPhrase: {
            firstLine: 'Tentez de',
            secondLine: 'gagner',
            fontFamily: 'var(--font-family-bold)',
          },
          maxReward: {
            backgroundImage: {
              imageUrl: 'assets/images/chondrus/ticket-yellow.svg',
              alternativeText:
                "Vous pouvez gagner jusqu'à {variable}€ en Tickets E.Leclerc dans ce parcours",
            },
            amountColor: '#005CB9',
            amountFontFamily: 'var(--font-family-edouard-condensed-bold)',
          },
          button: {
            label: 'Activer ce parcours',
            title: 'Activer ce parcours',
            color: 'white',
            fontFamily: 'var(--font-family-roboto-medium)',
            iconUrl: 'assets/images/chondrus/arrow-right-white.svg',
          },
        },
        unselectionButton: {
          variant: Variants.VARIANT_2,
          text: 'Désactiver ce Parcours',
          title: 'Désactiver ce parcours',
          color: '#D90000',
          fontFamily: 'var(--font-family-medium)',
        },
        outOfStock: {
          variant: Variants.VARIANT_1,
          backgroundColor: '#190c0db3',
          borderRadius: '10px',
          description: {
            backgroundColor: 'white',
            textColor: '#003494',
            fontFamily: 'var(--font-family-light)',
            text: 'Ce parcours à été victime<br/> de son succès !',
            fontSize: '18px',
          },
        },
      },
      step: {
        [SubType.DEFAULT]: {
          variant: Variants.VARIANT_4,
          bannerAlternativeText: 'Bannière des défis',
          logoAlternativeText: 'Bannière du logo',
          cardStyles: {
            border: '1px solid #003494',
          },
          header: {
            height: '144px',
            backgroundColor: '#B9DCFF',
          },
          subHeader: {
            color: 'white',
            completedBackgroundColor: '#005CB9',
            backgroundColor: '#005CB9',
            fontFamily: 'var(--font-family-roboto-medium)',
            fontSize: '12.66px',
          },
          body: {
            progressbar: {
              earnLabel: 'Je gagne',
              labelColor: '#003494',
              progressColor: '#003494',
              containerColor: '#9BB8EC',
              spendLabel: 'Si je dépense',
              labelFontFamily: 'var(--font-family-bold)',
            },
            rewardPastille: {
              onIcon: {
                imageUrl: 'assets/images/chondrus/ticket-yellow.svg',
                alternativeText:
                  'Vous avez gagné {variable}€ en atteignant ce défi.',
              },
              offIcon: {
                imageUrl: 'assets/images/chondrus/ticket-grey.svg',
                alternativeText:
                  "Vous pouvez gagner jusqu'à {variable}€ en atteignant ce défi.",
              },
              checkIcon: {
                imageUrl: 'assets/images/chondrus/ticket-check.svg',
              },
            },
            rewards: {
              color: '#005CB9',
              fontFamily: 'var(--font-family-edouard-condensed-bold)',
            },
            targetsFontFamily: 'var(--font-family-bold)',
          },
          footer: {
            label: {
              color: '#003494',
              fontFamily: 'var(--font-family-bold)',
              text: 'Mes achats : <span style="font-size: 1.54em; text-transform: none">{variable}</span>',
            },
            eligibleProductsBtn: {
              ariaLabel: 'Ouvrir la liste des produits',
              color: '#003494',
              label: 'Produits éligibles ?',
              fontFamily: 'var(--font-family-medium)',
            },
          },
        },
        // Parapharmacie parcours use the green universe instead of the blue one
        [ChondrusSubType.PARAPHARMACIE]: {
          variant: Variants.VARIANT_4,
          bannerAlternativeText: 'Bannière des défis',
          logoAlternativeText: 'Bannière du logo',
          cardStyles: {
            border: '1px solid #329A37',
          },
          header: {
            height: '144px',
            backgroundColor: '#C6F7C8',
          },
          subHeader: {
            color: 'white',
            completedBackgroundColor: '#329A37',
            backgroundColor: '#329A37',
            fontFamily: 'var(--font-family-roboto-medium)',
            fontSize: '12.66px',
          },
          body: {
            progressbar: {
              earnLabel: 'Je gagne',
              labelColor: '#003494',
              progressColor: '#003494',
              containerColor: '#9BB8EC',
              spendLabel: 'Si je dépense',
              labelFontFamily: 'var(--font-family-bold)',
            },
            rewardPastille: {
              onIcon: {
                imageUrl: 'assets/images/chondrus/ticket-yellow.svg',
                alternativeText:
                  'Vous avez gagné {variable}€ en atteignant ce défi.',
              },
              offIcon: {
                imageUrl: 'assets/images/chondrus/ticket-grey.svg',
                alternativeText:
                  "Vous pouvez gagner jusqu'à {variable}€ en atteignant ce défi.",
              },
              checkIcon: {
                imageUrl: 'assets/images/chondrus/ticket-check.svg',
              },
            },
            rewards: {
              color: '#005CB9',
              fontFamily: 'var(--font-family-edouard-condensed-bold)',
            },
            targetsFontFamily: 'var(--font-family-bold)',
          },
          footer: {
            label: {
              color: '#003494',
              fontFamily: 'var(--font-family-bold)',
              text: 'Mes achats : <span style="font-size: 1.54em; text-transform: none">{variable}</span>',
            },
            eligibleProductsBtn: {
              ariaLabel: 'Ouvrir la liste des produits',
              color: '#003494',
              label: 'Produits éligibles ?',
              fontFamily: 'var(--font-family-medium)',
            },
          },
        },
      },
      frequency: {
        [SubType.DEFAULT]: {
          variant: Variants.VARIANT_1,
          boxShadow: 'rgba(38, 38, 38, 0.08) 0px 4px 24px',
          header: {
            backgroundImage: {
              url: 'assets/images/default/frequency-banner.webp',
              bannerAriaLabel: 'Frequency Challenge',
            },
            height: '143px',
          },
          subHeader: {
            borderBottom: '1px solid #f4f5f6',
            completedBackgroundColor: '#005CB9',
            backgroundColor: '#005CB9',
            title: {
              color: 'white',
              fontFamily: 'var(--font-family)',
              label: 'Visits challenge',
            },
          },
          body: {
            label: 'Minimum amount of {variable}€ per visit',
            labelFontFamily: 'var(--font-family-bold)',
            labelFontSize: '14px',
            stamps: {
              showNumbers: false,
              iconSelected: 'assets/images/default/frequency-stamp-success.svg',
              iconNonSelected:
                'assets/images/default/frequency-stamp-empty.svg',
              itemMaxWidth: '40px',
            },
          },
          footer: {
            color: 'black',
            label: 'Visits: ',
            fontFamily: 'var(--font-family)',
          },
        },
      },
    },
    challengeSummary: {
      variant: Variants.VARIANT_4,
      title: {
        text: 'Vos parcours',
        color: 'white',
        fontFamily: 'var(--font-family-bold)',
      },
      update: {
        color: 'white',
        text: 'Mise à jour le {variable}',
        fontFamily: 'var(--font-family-roboto-medium)',
        dateFormat: 'dd/MM/yy',
      },
      label: {
        color: 'white',
        mobileText: 'Défis sélectionnés',
        desktopText: 'Défis sélectionnés',
        backgroundColor: 'rgba(255, 255, 255, 0.2)',
        fontFamily: 'var(--font-family-bold)',
      },
      completedLabel: 'Défis terminés',
      separatorIconUrl: 'assets/images/chondrus/star-white.svg',
      tooltip: {
        visible: true,
        icon: 'assets/images/chondrus/info-white.svg',
        content:
          "Mise à jour des Parcours <br/>Vos transactions peuvent mettre jusqu'à 72 heures à apparaître. <br/> Si vous avez des questions, consultez les FAQ dans la rubrique «Aide» et si vous ne trouvez pas la réponse à votre question, renseignez-la dans le formulaire.",
        position: 'right',
        alternativeText: 'Cliquez pour afficher le message',
      },
    },
    modals: {
      closeButton: {
        label: 'Fermer',
        textColor: 'white',
        borderRadius: '50px',
        backgroundColor: '#FF8615',
        fontFamily: 'var(--font-family-bold)',
        ariaLabel: 'Fermer cette boîte de dialogue',
      },
      unselectChallenge: {
        ariaLabel: 'Désélectionner le défi',
        backgroundColor: '#FFFFFF',
        header: {
          logo: {
            alternativeText: 'Bannière de la marque',
          },
          backgroundColor: '#003494',
          backgroundImage: '',
        },
        frequencyHeaderImages: {
          [SubType.DEFAULT]: {
            imageUrl: 'assets/images/default/frequency-header.webp',
            alternativeText: '',
          },
        },
        title: {
          color: '#FF8615',
          fontFamily: 'var(--font-family-medium)',
          label: ' Êtes-vous sûr(e) de vouloir <br/>abandonner ce parcours ?',
        },
        body: {
          color: '#747474',
          fontFamily: 'var(--font-family-normal)',
          label:
            'Pas d’inquiétude, vous pourrez le sélectionner<br/> à nouveau si vous le souhaitez.',
        },

        actionButtons: {
          variant: Variants.VARIANT_1,
          confirmButton: {
            label: 'Oui',
            borderRadius: '50px',
            textColor: '#FFFFFF',
            backgroundColor: '#003494',
            fontFamily: 'var(--font-family-bold)',
            ariaLabel: 'Fermer la boîte de dialogue en confirmant',
          },
          closeButton: {
            label: 'Non',
            borderRadius: '50px',
            textColor: 'white',
            backgroundColor: '#FF8615',
            fontFamily: 'var(--font-family-bold)',
            ariaLabel: 'Fermer la boîte de dialogue sans confirmer',
          },
        },
      },
      selectionIssue: {
        backgroundColor: '#FFFFFF',
        title: {
          color: '#272f35',
          fontFamily: 'var(--font-family-bold)',
          label: 'Problème détecté sur votre compte',
        },
        body: {
          color: '#6b767c',
          fontFamily: 'var(--font-family)',
          label:
            "Un problème a été détecté sur votre compte. Veuillez contacter notre équipe d'assistance pour obtenir de l'aide. Nous sommes là pour résoudre ce souci dans les plus brefs délais.",
        },
      },
      productCheck: {
        ariaLabel: 'Vérification du produit',
        backgroundColor: '#FFFFFF',
        fontFamily: 'var(--font-family-light)',
        tabs: [
          {
            type: ProductCheckTabType.SCAN,
            checkMode: ScanCheckMode.PRODUCT_LIST,
            hideOnAndroid: true,
            label: 'SCANNER',
            successMessage: 'Succès',
            title: 'Scannez votre code barre !',
            startButtonLabel: 'Démarrer le scanner',
            retryPermissionButtonLabel: "Réessayer l'accès à la caméra",
            restartButtonLabel: 'Redémarrer le scanner',
            errorMessage: 'Non éligible pour ce challenge',
            errorWhenCameraPermissionDenied:
              "Veuillez autoriser l'accès à la caméra pour utiliser le scanner.",
            failureMessage: 'Une erreur est survenue, veuillez réessayer',
            errorWhenCameraNotFound: 'Caméra non disponible',
            errorWhenCameraBusy:
              'La caméra est utilisée par une autre application. Fermez-la, puis réessayez.',
            previewLabel: 'Aperçu du scanner de code-barres',
            readers: [BARCODE_FORMAT.EAN_8, BARCODE_FORMAT.EAN_13],
          },
          {
            type: ProductCheckTabType.PRODUCT_LIST,
            failureMessage: 'Une erreur est survenue, veuillez réessayer',
            label: 'CODE BARRE',
            searchable: true,
            inputPlaceholder: 'Saisissez un code-barres',
            tableTitle: {
              text: 'Liste des produits éligibles',
              color: '#FF8615',
            },
            columns: {
              name: {
                header: 'Produit',
                color: '#003494',
                fontFamily: 'var(--font-family-light)',
              },
              code: {
                header: 'Code barre',
                color: '#003494',
                fontFamily: 'var(--font-family-normal)',
              },
            },
          },
        ],
      },
      firstSelection: {
        backgroundColor: 'white',
        title: {
          color: '#FF8615',
          label: '1ère sélection !',
          fontFamily: 'var(--font-family-medium)',
        },
        header: {
          backgroundImage: '',
          backgroundColor: 'white',
          logo: {
            imageUrl: 'assets/images/chondrus/first-selection.svg',
            alternativeText:
              'Félicitations, vous avez sélectionné votre premier parcours !',
          },
        },
        body: {
          color: '#747474',
          fontFamily: 'var(--font-family-light)',
          label:
            'Félicitations, vous avez sélectionné votre premier parcours !',
        },
      },
      redirectionWarning: {
        backgroundColor: 'white',
        title: {
          color: '#003494',
          label:
            'Veuillez vous reconnecter à votre compte pour pouvoir sélectionner les Parcours.',
          fontFamily: 'var(--font-family-roboto-medium)',
        },
        body: {
          label: '',
          color: '#003494',
          fontFamily: 'var(--font-family-roboto-light)',
        },
      },
      optins: {
        backgroundColor: 'white',
        title: {
          color: '#003494',
          label: 'BRAVO !',
          fontFamily: 'var(--font-family-bold)',
        },
        subtitle: {
          color: '#FF8615',
          label: 'VOUS VENEZ DE SÉLECTIONNER UN PREMIER PARCOURS*!',
          fontFamily: 'var(--font-family-bold)',
        },
        body: {
          color: '#003494',
          fontFamily: 'var(--font-family-roboto-bold)',
          label: `Pour pouvoir jouer dans le cadre de l'opération Parcours Gagnants, vous devez nous autoriser à vous présenter des offres qui correspondent à vos achats et vos envies.  Vous pourrez ainsi sélectionner jusqu'à 10 parcours afin de gagner jusqu'à 50€ en Tickets <a href="https://e.leclerc" target="_blank">E.Leclerc</a>.`,
        },
        checkbox: {
          color: '#003494',
          fontFamily: 'var(--font-family-roboto-light)',
          label: `Je souhaite que l'enseigne E.Leclerc (1) me fasse profiter d'offres et
          d'avantages personnalisés selon mes achats et mon intérêt pour ses
          communications (2) <br />Si vous les acceptez, nos e-mails intègrent un
          marqueur de suivi pour mesurer l'intérêt porté à nos communications.
          Cela nous permet d'adapter la fréquence et la pertinence des contenus
          adressés.`,
          errorMessage: 'Vous devez accepter les modalités pour continuer',
        },
        templateOptinsDetails: [
          `<div class="point">
        <div class="intro">
          *Les marques proposées dans un premier temps sont des marques non
          personnalisées. Dès la validation de votre consentement, un délai
          minimum de trois semaines avant la date de la nouvelle opération
          Parcours Gagnants est nécessaire pour bénéficier des Parcours avec des
          marques personnalisées.
        </div>
        <div class="point-title">
          (1) Quelles sont les sociétés de l'enseigne E.Leclerc ?
        </div>
        <div class="point-content">
          Votre adresse email et/ou votre numéro de téléphone mobile seront
          transmis uniquement aux sociétés de l'enseigne E.Leclerc. Vous pourrez
          recevoir des emails et/ou des sms de la part de :
          <ul>
            <li>
              Votre magasin E.Leclerc et ses magasins spécialisés (parapharmacie,
              optique, l'auto, station-service, drive, animalerie, brico, jardi,
              jouet, le manège à bijoux, une heure pour soi, espace culturel,
              location, sport, voyages, occasion),
            </li>
            <li>
              La société L-Commerce, qui édite les sites E.Leclerc,
              maisonetloisirs.leclerc, optique.leclerc, photo.leclerc,
              e-librairie.leclerc, auto.leclerc,
            </li>
            <li>
              Le Groupement d'Achat des Centres E.Leclerc (SC GALEC) qui réalise
              la communication commerciale E.Leclerc,
            </li>
            <li>
              Les sociétés qui gèrent la livraison à domicile ou en point relais,
            </li>
            <li>
              La société E.Leclerc Voyages qui édite le site leclercvoyages.com,
            </li>
            <li>
              La société Siplec spécialisée dans les métiers de l’énergie et dans
              l’approvisionnement de produits manufacturés pour l’enseigne
              E.Leclerc et l'édition des sites primes-energie.leclerc,
              energies.leclerc et cartecarburant.leclerc, sous la marque E.LECLERC
              ENERGIES,
            </li>
            <li>La société Devinlec qui édite le site lemanegeabijoux.com,</li>
            <li>
              La Banque Edel qui participe notamment à la gestion des cartes
              cadeau E.Leclerc, des cartes de crédit REGLO finance et des produits
              d'assurance Garantie Remboursement Intégral,
            </li>
            <li>La société L Telecom qui édite le site reglomobile.fr,</li>
            <li>
              La société Conso Régie qui est la régie publicitaire de l'enseigne
              E.Leclerc et met en ligne des publicités pour l'enseigne E.Leclerc.
            </li>
          </ul>
        </div>
      </div>

      <div class="point">
        <div class="point-title">
          (2) Comment sont adaptées les offres E.Leclerc en fonction de mes achats
          et de mon intérêt pour ses communications e-mails
        </div>
        <div class="point-content">
          Un profilage est réalisé à partir de votre historique d'achats aux fins
          d'adapter les offres commerciales qui vous sont adressées, si vous avez
          préalablement donné votre consentement à un tel traitement.
          <br />
          Ce profilage permet une segmentation des clients titulaires d'un compte
          sur un site de l'enseigne E.Leclerc et/ou d'une carte de fidélité
          E.Leclerc, une distribution d'échantillons personnalisés ainsi que la
          diffusion de manière automatisée d'offres commerciales personnalisées
          sur divers supports (ticket de caisse, courrier, bannière publicitaire
          sur internet et applications mobiles, télévision segmentée et, si vous
          y avez consenti, par email et/ou SMS).
          <br />
          Le profilage s'effectue par un suivi de vos achats dans chacun des
          circuits de distribution E.Leclerc (hypermarché, supermarché, Express,
          Drive, magasins spécialisés et applications / sites internet marchands
          E.Leclerc), en considérant le contenu de votre panier d'achat. Ce suivi
          tient compte de votre fidélité dans le temps.
          <br />
          Les moyens du suivi sont l'utilisation du compte client unique, de la
          carte de fidélité E.Leclerc, ainsi que de l'utilisation des
          applications et sites internet marchands E.Leclerc.
          <br />
          Si vous acceptez de recevoir des communications par email, nous
          utilisons des marqueurs (pixels de suivi) pour analyser vos
          interactions avec nos messages (heure d'ouverture des emails, clics,
          type de terminal utilisé). Ces informations nous aident à mesurer la
          performance de nos campagnes afin d'ajuster la fréquence et l'heure de
          nos envois, de privilégier le canal de communication qui vous convient
          le mieux et de vous proposer des contenus personnalisés, adaptés à vos
          besoins.
          <br />
          Les données utilisées pour le profilage sont celles que vous nous avez
          fournies directement, celles qui sont générées par votre activité au
          sein de l'enseigne E.Leclerc et celles dérivées ou déduites des
          précédentes. Dans l'hypothèse où vous consentez à profiter d'offres et
          d'avantages qui correspondent à vos achats et vos envies, ces données
          pourront être transmises aux destinataires énumérés dans la liste des
          sociétés de l'enseigne E.Leclerc.
        </div>
      </div>`,
        ],
        actionButtons: {
          variant: Variants.VARIANT_1,
          confirmButton: {
            label: 'Valider',
            borderRadius: '50px',
            textColor: '#FFFFFF',
            backgroundColor: '#003494',
            fontFamily: 'var(--font-family-roboto-medium)',
            ariaLabel: 'Fermer la boîte de dialogue en confirmant',
          },
          closeButton: {
            label: 'Fermer',
            borderRadius: '50px',
            textColor: 'white',
            backgroundColor: '#FF8615',
            fontFamily: 'var(--font-family-roboto-medium)',
            ariaLabel: 'Fermer la boîte de dialogue sans confirmer',
          },
        },
      },
      optinsCloseConfirmation: {
        backgroundColor: 'white',
        title: {
          color: '#003494',
          label:
            "Vous n'avez pas donné votre consentement, vous ne pouvez pas jouer.",
          fontFamily: 'var(--font-family-bold)',
        },
        header: {
          backgroundImage: '',
          backgroundColor: '',
        },
        body: {
          color: '#003494',
          fontFamily: 'var(--font-family-roboto-bold)',
          label: ``,
        },
        actionButtons: {
          variant: Variants.VARIANT_1,
          confirmButton: {
            label: 'Donner mon consentement',
            borderRadius: '50px',
            textColor: '#FFFFFF',
            backgroundColor: '#003494',
            fontFamily: 'var(--font-family-roboto-medium)',
            ariaLabel: 'Donner mon consentement',
          },
          closeButton: {
            label: 'Fermer',
            borderRadius: '50px',
            textColor: 'white',
            backgroundColor: '#FF8615',
            fontFamily: 'var(--font-family-roboto-medium)',
            ariaLabel: 'Fermer',
          },
        },
      },
      lastSelection: {
        backgroundColor: 'white',
        title: {
          color: '#FF8615',
          fontFamily: 'var(--font-family-medium)',
          label: 'Tu veux cagnotter encore plus de Tickets ?',
        },
        header: {
          backgroundImage: '',
          backgroundColor: 'white',
          logo: {
            imageUrl: 'assets/images/chondrus/last-selection.svg',
            alternativeText:
              'Tu veux gagner encore plus de tickets ? Découvre les Parcours Bonus+, d’autres défis t’attendent',
          },
        },
        body: {
          color: '#747474',
          fontFamily: 'var(--font-family-light)',
          label:
            'N’oublie pas d’aller découvrir tes Parcours Bonus +, <br/>d’autres challenges t’attendent !',
        },
      },
      maximumSelection: {
        backgroundColor: 'white',
        title: {
          color: '#FF8615',
          label: 'À vous de jouer !',
          fontFamily: 'var(--font-family-medium)',
        },
        header: {
          backgroundImage: '',
          backgroundColor: 'white',
          logo: {
            imageUrl: 'assets/images/chondrus/maximum-selection.svg',
            alternativeText:
              'À vous de jouer ! Vous avez sélectionné vos {variable} parcours. Pour changer, désélectionnez un parcours non commencé et choisissez-en un autre.',
          },
        },
        body: {
          color: '#747474',
          fontFamily: 'var(--font-family-light)',
          label:
            "Vous avez déjà sélectionné vos {variable} parcours. pour obtenir les récompenses !<br/><br/>Si vous changez d'avis, vous pouvez désélectionner un parcours non commencé pour en sélectionner un autre.",
        },
      },
      authError: {
        backgroundURL: {
          mobile: 'assets/images/chondrus/back-modal-mobile.svg',
          tablet: 'assets/images/chondrus/back-modal-desktop.svg',
          desktop: 'assets/images/chondrus/back-modal-desktop.svg',
        },
        titles: [
          '<div style="text-transform: uppercase; font-family: var(--font-family-bold); margin-top: 10px">',
          '<h1 style="position: absolute;clip: rect(0, 0, 0, 0);overflow: hidden;">Atuthentification</h1>',
          '<h2 style="font-size: 27px; color: #2868c5; margin: 40px auto 0;">Désolé, mais vous ne remplissez pas</h2>',
          '<h2 style="font-size: 35px; color: #2868c5; margin-top: 0;">Les conditions pour participer...</h2>',
          '<h3 style="font-size: 28px; color: #FF8615;">Quelles sont les conditions pour participer ?</h3>',
          '</div>',
        ],
        content: [
          '<div class="conditions" style="display: flex; align-items: flex-start;">',
          '<img alt="" style="width: 30px; margin-right: 10px;" alt="" src="assets/images/chondrus/01.svg" />',
          '<p style="color: #2868c5; padding-bottom: 20px; font-size: 12px; line-height: 23px; padding-right: 5px; margin: 0;">Etre détenteur de la Carte de Fidélité E.Leclerc et l’avoir rattachée dans votre compte client sur les sites E.leclerc, Drive E.Leclerc ou dans les applications mobiles Mon E.leclerc ou LeclercDrive.</p>',
          '</div>',
          '<div class="conditions" style="display: flex; align-items: flex-start;">',
          '<img alt="" style="width: 30px; margin-right: 10px;" alt="" src="assets/images/chondrus/02.svg" />',
          '<p style="color: #2868c5; padding-bottom: 20px; font-size: 12px; line-height: 23px; padding-right: 5px; margin: 0;">Avoir renseigné votre magasin préféré dans votre compte Carte E.Leclerc (magasin de France Métropolitaine ou de Corse) dans votre compte client sur le sites E.Leclerc, Drive E.Leclerc.</p>',
          '</div>',
          '<div class="conditions" style="display: flex; align-items: flex-start;">',
          '<img alt="" style="width: 30px; margin-right: 10px;" alt="" src="assets/images/chondrus/03.svg" />',
          '<p style="color: #2868c5; padding-bottom: 20px; font-size: 12px; line-height: 23px; padding-right: 5px; margin: 0;">Avoir donné votre accord pour que l’enseigne E.Leclerc(1) vous fasse profiter d’offres et d’avantages personnalisés selon vos achats et votre intérêt pour ses communications(2). Pour donner votre accord, rendez-vous dans votre compte client sur les sites E.Leclerc, Drive E.Leclerc ou dans les applications mobiles Mon E.Leclerc ou Drive E.Leclerc.</p>',
          '</div>',
        ],
        closeButton: {
          imageUrl: 'assets/images/chondrus/cancel-icon.svg',
          ariaLabel: 'Fermer la boîte de dialogue',
          alternativeText: 'Icône de fermeture',
          title: 'Fermer la boîte de dialogue',
        },
      },
      outOfStockIssue: {
        backgroundColor: '#FFFFFF',
        title: {
          color: '#272f35',
          fontFamily: 'var(--font-family-bold)',
          label: 'Limite atteinte',
        },
        body: {
          color: '#6b767c',
          fontFamily: 'var(--font-family)',
          label:
            'Ce parcours a atteint le nombre maximal de participants. Veuillez en choisir un autre.',
        },
      },
      genericError: {
        backgroundColor: '#FFFFFF',
        title: {
          color: '#272f35',
          fontFamily: 'var(--font-family-bold)',
          label: 'Erreur',
        },
        body: {
          color: '#6b767c',
          fontFamily: 'var(--font-family)',
          label:
            'Une erreur est survenue et le parcours n’a pas pu être sélectionné. Veuillez vérifier votre connexion et réessayer.',
        },
      },
      timeoutError: {
        backgroundColor: '#FFFFFF',
        title: {
          color: '#272f35',
          fontFamily: 'var(--font-family-bold)',
          label: 'Délai dépassé',
        },
        body: {
          color: '#6b767c',
          fontFamily: 'var(--font-family)',
          label:
            'La sélection du parcours a pris trop de temps. Veuillez vérifier votre connexion et réessayer.',
        },
      },
      challengeUnavailable: {
        backgroundColor: '#FFFFFF',
        title: {
          color: '#272f35',
          fontFamily: 'var(--font-family-bold)',
          label: 'Campagne terminée',
        },
        body: {
          color: '#6b767c',
          fontFamily: 'var(--font-family)',
          label:
            'Cette campagne est terminée, les parcours ne sont plus disponibles à la sélection.',
        },
      },
    },
  },
  scripts: [
    {
      id: 'ze-snippet',
      loadInIframe: false,
      src: 'https://static.zdassets.com/ekr/snippet.js?key=62082d98-ea6e-4240-85ab-f5413f640d91',
    },
  ],
};
